import { CreateTaskData, GetAttachments } from '@/api/fishing-task'
import { IconFont, SvgIcon, SignTitle, TemplateItem, SearchInput, AiMailModal } from '@/components'
import { SearchInputTwo } from '@/components/search-input-two'
import { Dispaths } from '@/types'
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { useCheditor } from '@/utils'
import { disabledDate, disabledDateTime } from '@/utils/appointment'
import {
  useDebounce,
  useDebounceFn,
  useLocalStorageState,
  useRequest,
  useSelections,
  useVirtualList,
} from 'ahooks'
import Scrollbars from 'react-custom-scrollbars'
import {
  Button,
  Space,
  Form,
  Input,
  Row,
  Col,
  DatePicker,
  Card,
  Select,
  Checkbox,
  Tooltip,
  Modal,
  Typography,
  InputNumber,
  Tree,
  Switch,
} from 'antd'
const { Option } = Select
import moment from 'moment'
import React, { useContext, useEffect, useMemo, useRef } from 'react'
import { useState } from 'react'
import styled from 'styled-components'
import { ArticleSteps } from '@/components/article-steps'
import {
  useCreateTask,
  useGetAttachments,
  useGetEmailTemplate,
  useGetPages,
  useGetEmailDetail,
  useGetTargetList,
  useGetTargetDomain,
  useGetSecyTemplate,
  useGetCampaignSmtp,
  useGetAiEmailTemplate,
  useCreateAiEmailTemplate,
  useGetAiPhishingPageTemplate,
  useCreateAiPhishingPageTemplate,
} from './utils'
import { useGetAuthorizeConfig } from '@/pages/account-center/authorize-manage/utils'
import { useGetPhishingPages, useGetAttachments as useGetAttachments2 } from '../template/utils'
import { Radio } from 'antd'
import {
  AttachmentRight,
  TaskAccessoryRight,
  TaskEmailEncryption,
  TaskEmailRight,
  TaskNameRight,
  TaskOverRight,
  TaskPhishingRight,
  TaskPhishRight,
  TaskRedirectRight,
  TaskSpiteRight,
  TaskTypeRight,
} from './create-right'
import { useNavigate } from 'react-router-dom'
import { useAddTarget, useGetGroupList, useGetTagList, useGetTotal } from '../target/utils'
import { usePutAttachmentName, useCheckAvailableStatus } from '../template/utils'
import { useLocation } from 'react-router'
import OverviewLine from '@/assets/imges/phishing/create/overview_line1.png'
import { Message } from '@/components/message'
import { useAppSelector } from '@/redux/hooks'
import { isTimeInRange } from '@/redux/taskSlice'
import { t } from '@/i18n'
const { useForm } = Form

const TaskName = () => {
  const isAll = useAppSelector(state => state.task.isAll)
  const pauseEnabled = useAppSelector(state => state.task.pauseEnabled)
  const pauseWeek = useAppSelector(state => state.task.pauseWeek)
  const startTime = useAppSelector(state => state.task.startTime)
  const endTime = useAppSelector(state => state.task.endTime)
  /** 用于控制滚动条位置*/
  const listRef = useRef<HTMLDivElement>(null)
  const [form] = useForm()
  const [createForm] = useForm()
  const { dispatch, data } = useCreateTaskContext()
  const { submitData } = data
  const [messages, setMessages] = useLocalStorageState<any>('assess', {
    defaultValue: [],
  })
  const { setSteps, setSubmitData, setCreateVisibel } = dispatch

  const submitHandler = (values: any) => {
    if (execute === 2 && taskTime === '') {
      Message.error(t('请选择任务开始时间'))
      return
    }
    setSub(true)
    setSubmitData(origin => ({
      ...origin,
      taskName: values['task-name'],
      start_time: taskTime,
      execution: execution,
      set_type: execute,
    }))
    setMessages([])
    setSteps(2)
  }
  // 获取邮箱授权数量
  const [authorizeConfig, runAuthorizeConfig] = useGetAuthorizeConfig()
  const [getTargetDomain, getDomainLoading, targetDomain] = useGetTargetDomain()
  const days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]
  let [execute, setExecute] = useState<any>(submitData.set_type || 1)
  let [execution, setExecution] = useState<number>(submitData.execution || 7)
  let [taskTime, setTaskTime] = useState(submitData?.start_time || '')
  const [tagList, getTagList] = useGetTagList()
  const [targetVisible, setTargetVisible] = useState(false)
  const [target, setTarget] = useState<string[]>([])
  const [addTarget] = useAddTarget()
  const [selectGroup, setSelectGroup] = useState({ id: null, name: null })
  const [getGroupList, groupList] = useGetGroupList()
  let [inputValue, setInputValue] = useState(submitData?.taskName || '')
  const [addEmail, setAddEmail] = useState(null)
  const [errorData, setErrorData] = useState(null)
  const [getTotal] = useGetTotal()
  const [field, setField] = useState(1)
  const [total, setTotal] = useState(0)
  const [isPause, setIsPause] = useState(false)

  const EmailTotal = useMemo(() => {
    if (total >= authorizeConfig?.emailAuthTotal) {
      createForm.setFieldsValue({ users: [] })
      return total
    }
    return total + field
  }, [field, total])

  useEffect(() => {
    runAuthorizeConfig().catch(_ => {})
  }, [targetVisible])

  useEffect(() => {
    if (
      (total >= authorizeConfig?.emailAuthTotal || EmailTotal > authorizeConfig?.emailAuthTotal) &&
      targetVisible
    )
      Message.error(t('超出数量限制，无法添加'))
  }, [EmailTotal, targetVisible])

  useEffect(() => {
    const current = listRef.current
    if (!current) return
    //scrollHeight是页面的高度
    current.scrollTop = current.scrollHeight
  }, [field])

  useEffect(() => {
    // 未开启
    if (!pauseEnabled) {
      setIsPause(false)
      return
    }

    // 全时段暂停
    if (isAll) {
      setIsPause(true)
      return
    }

    // 自定义暂停
    const week = moment().day()
    const current = {
      hour: moment().hours(),
      minute: Number(moment().format('hh:mm:ss').split(':')[1]),
      second: Number(moment().format('hh:mm:ss').split(':')[2]),
    }

    // 非暂停时间段 (天）
    if (!pauseWeek.includes(week)) {
      setIsPause(false)
      return
    } else {
      // 非暂停时间段 (时分秒)
      if (!isTimeInRange(current, startTime, endTime)) {
        setIsPause(false)
        return
      }
      setIsPause(true)
    }
  }, [])

  const onFinish = async values => {
    try {
      const { users } = values
      if (EmailTotal > authorizeConfig?.emailAuthTotal) {
        Message.error(t('超出数量限制，无法添加'))
        return
      }
      let arr = []
      users?.map((item, index) => {
        arr.push(item)
        arr[index].dept_name = selectGroup.name
        arr[index].group_id = selectGroup.id
      })
      console.log('arr', arr)
      await addTarget({
        targets: arr,
      })
      setAddEmail(Date.now())
      setTargetVisible(false)
      createForm.resetFields()
    } catch (error: any) {
      if (error.code === 408) {
        setErrorData(error.data)
      }
    }
  }
  const getTarget = (targetString: string[]) => {
    setTarget(targetString)
  }
  const [sub, setSub] = useState(false)
  const { run } = useRequest(
    (e): any => {
      let arr = null
      if (errorData?.length > 0) {
        arr = []
      }
      errorData?.map(item => {
        if ((item.index || 0) !== e.key) {
          arr.push(item)
        }
      })
      setErrorData(arr)
    },
    {
      debounceWait: 300, // 防抖等待时间, 单位为毫秒，设置后，进入防抖模式
      manual: true,
    },
  )
  return (
    <ModalContent>
      <div className="body">
        <div style={{ width: '100%' }}>
          <Form
            form={form}
            onFinish={submitHandler}
            layout={'vertical'}
            initialValues={{
              'task-name': submitData?.taskName,
              type: submitData?.set_type,
            }}
          >
            <div className="tasks-background" style={{ marginBottom: 16 }}>
              <Form.Item
                label={t('任务名称')}
                name={'task-name'}
                rules={[
                  { required: true, message: t('任务名称不允许为空') },
                  {
                    pattern: /^(?=.*\S).+$/,
                    message: t('任务名称不能全部为空格!'),
                  },
                  {
                    max: 50,
                    message: t('任务名称最多50个字'),
                  },
                ]}
                style={{ marginBottom: 0, flex: 1, paddingRight: 24 }}
              >
                <Input
                  placeholder={t('请输入任务名称')}
                  onChange={e => setInputValue(e.target.value)}
                />
              </Form.Item>
              <div style={{ padding: '30px 0', width: 1, background: '#DFDFDF' }} />
              <Form.Item
                label={t('任务开始时间')}
                required
                style={{ flex: 1, marginBottom: 0, padding: '0 24px' }}
                name="type"
              >
                <Radio.Group
                  defaultValue={submitData?.set_type || 1}
                  onChange={e => {
                    setExecute((execute = e.target.value))
                  }}
                  style={{ display: 'flex' }}
                >
                  <Radio.Button value={1}>{t('立即')}</Radio.Button>
                  <Radio.Button value={2}>{t('预定')}</Radio.Button>
                </Radio.Group>
                {execute === 2 && (
                  <>
                    <DatePicker
                      showTime
                      defaultValue={submitData?.start_time ? moment(submitData?.start_time) : null}
                      style={{ width: 245 }}
                      onChange={(value, dateString) => {
                        setTaskTime((taskTime = dateString))
                      }}
                      placeholder={t('请选择日期与时间')}
                      disabledDate={disabledDate}
                      disabledTime={disabledDateTime}
                    />
                  </>
                )}
              </Form.Item>
              <div style={{ padding: '30px 0', width: 1, background: '#DFDFDF' }} />
              <Form.Item
                label={t('任务时长')}
                name="time"
                style={{ flex: 1, marginBottom: 0, padding: '0 24px' }}
              >
                <Select
                  placeholder={t('请选择')}
                  defaultValue={submitData?.execution || 7}
                  onChange={e => setExecution((execution = e))}
                >
                  {days?.map(item => (
                    <Select.Option key={item} value={item}>
                      {item}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <div className="form-position">{t('天')}</div>
            </div>
          </Form>
          <img src={OverviewLine} alt="" style={{ width: '100%', height: 2, marginBottom: 10 }} />
          <Card
            className="target"
            style={{ height: 'calc(100% - 200px)', border: 0 }}
            title={
              <>
                <span style={{ color: '#F53F3F' }}>*</span>
                <span>{t('评估目标')}</span>
              </>
            }
            bodyStyle={{ padding: '0', marginTop: 16 }}
          >
            <AssessTarget getTarget={getTarget} sub={sub} addEmail={addEmail} execute={execute} />
          </Card>
        </div>
      </div>
      <AddEmailModal
        title={
          <div style={{ display: 'flex', alignItems: 'flex-end' }}>
            <SignTitle show style={{ width: 84 }}>
              {t('添加邮箱')}
            </SignTitle>
            <span style={{ fontSize: 14, color: '#666666' }}>
              {t('（已添加')} <span style={{ color: '#558492' }}>{EmailTotal}</span> /
              {authorizeConfig?.emailAuthTotal} {t('人）')}
            </span>
          </div>
        }
        visible={targetVisible}
        centered
        width={800}
        destroyOnClose
        onOk={() => createForm.submit()}
        onCancel={() => {
          setTargetVisible(false)
          setErrorData([])
          createForm.resetFields()
        }}
        bodyStyle={{ height: 600 }}
        footer={
          <div style={{ display: 'flex', paddingRight: '10px', justifyContent: 'flex-end' }}>
            <div style={{ display: 'flex', marginLeft: 16 }}>
              <Button
                onClick={() => {
                  setTargetVisible(false)
                  createForm.resetFields()
                  setErrorData([])
                }}
              >
                {t('取消')}
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  createForm.submit()
                }}
                disabled={
                  total >= authorizeConfig?.emailAuthTotal ||
                  EmailTotal > authorizeConfig?.emailAuthTotal
                }
              >
                {t('确定')}
              </Button>
            </div>
          </div>
        }
      >
        <Form
          form={createForm}
          onFinish={onFinish}
          layout={'vertical'}
          style={{ marginTop: 16 }}
          initialValues={{ users: [] }}
        >
          <Form.Item
            name="gender"
            label={t('部门')}
            rules={[{ required: true, message: t('请选择部门') }]}
            style={{ width: 322 }}
          >
            <Select
              placeholder={t('请选择')}
              onChange={(_, event: any) => {
                setSelectGroup({ id: event.value, name: event.children })
              }}
            >
              {groupList?.items?.map(
                item =>
                  item.id && (
                    <Option value={item.id} key={item.id}>
                      {item.name}
                    </Option>
                  ),
              )}
            </Select>
          </Form.Item>
          <div style={{ fontSize: 12, marginBottom: 10, maxHeight: 120, overflowY: 'scroll' }}>
            <span style={{ color: '#F53F3F' }}>*</span>
            {t('可添加的邮箱域名：')}
            <span
              style={{
                color: '#558492',
                width: 460,
                wordWrap: 'break-word',
                wordBreak: 'break-all',
              }}
            >
              {targetDomain?.map((item, index) => (
                <span key={index}>
                  {item.domain}
                  {targetDomain.length - 1 !== index && ','}
                </span>
              ))}
            </span>
            {t('如需新增邮箱域名，请在资产认证中添加域并认证。')}
          </div>
          <div
            style={{
              background: '#F7F8F9',
              borderRadius: 6,
              padding: 15,
              overflow: 'auto',
              height: 456,
              position: 'relative',
              paddingRight: 0,
            }}
          >
            <Form.List name="users">
              {(fields, { add, remove }) => {
                setField(fields?.length)
                return (
                  <>
                    <div className="email-main" ref={listRef} style={{ scrollBehavior: 'smooth' }}>
                      {fields.map(({ key, name, ...restField }) => (
                        <div style={{ display: 'flex', width: 700 }} key={key}>
                          <Form.Item
                            {...restField}
                            name={[name, 'email']}
                            label={t('邮箱')}
                            rules={[
                              { required: true, message: t('请输入邮箱') },
                              {
                                validator: (_, value: string) => {
                                  if (!value) return Promise.resolve()
                                  if (
                                    !/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)
                                  ) {
                                    return Promise.reject(t('请输入正确的邮箱格式'))
                                  }
                                  if (
                                    value &&
                                    !targetDomain.some(item => value.includes(item.domain))
                                  ) {
                                    return Promise.reject(t('邮箱域名错误'))
                                  } else {
                                    return Promise.resolve('12')
                                  }
                                },
                              },
                            ]}
                            validateStatus={
                              (errorData?.some(item => (item?.index || 0) === key) && 'error') ||
                              undefined
                            }
                            help={
                              errorData?.filter(item => (item?.index || 0) === key)?.[0]?.message ||
                              undefined
                            }
                            style={{ flex: 1 }}
                          >
                            <Input
                              placeholder={t('请输入')}
                              onChange={e => {
                                run({ name: e.target.value, key: key })
                              }}
                            />
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            name={[name, 'name']}
                            label={t('姓名')}
                            style={{ margin: '0 10px', flex: 1 }}
                            rules={[{ max: 15, message: t('姓名最多15字') }]}
                          >
                            <Input placeholder={t('请输入')} />
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            label={t('标签')}
                            name={[name, 'tag_ids']}
                            style={{ flex: 1 }}
                          >
                            <Select
                              placeholder={t('请选择标签')}
                              mode="multiple"
                              showSearch={false}
                              showArrow
                              // maxTagCount={2}
                              // maxTagTextLength={5}
                            >
                              {getTagList?.map(item => (
                                <Option value={item?.id} key={item?.id}>
                                  {item?.name}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <IconFont
                              type={'icon-shanchu-m'}
                              style={{ marginLeft: 10, width: 14, height: 14 }}
                              onClick={() => {
                                remove(name)
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="add">
                      <Tooltip
                        title={
                          authorizeConfig?.emailAuthTotal - authorizeConfig?.emailAuthUsed <= 0
                            ? t('请提升验证邮箱授权数量')
                            : ''
                        }
                      >
                        <Button
                          type="primary"
                          onClick={() => {
                            if (EmailTotal >= authorizeConfig?.emailAuthTotal) {
                              return
                            }
                            add()
                          }}
                          style={{
                            cursor:
                              EmailTotal >= authorizeConfig?.emailAuthTotal ? 'no-drop' : 'pointer',
                            width: 100,
                          }}
                          disabled={EmailTotal >= authorizeConfig?.emailAuthTotal}
                        >
                          <IconFont type="icon-zengjia" />
                          <span>{t('添加')}</span>
                        </Button>
                      </Tooltip>
                    </div>
                  </>
                )
              }}
            </Form.List>
          </div>
        </Form>
      </AddEmailModal>
      <div className="footer">
        <ArticleSteps currentNum={0} length={6} />
        <Space>
          <Tooltip
            title={
              authorizeConfig?.emailAuthTotal - authorizeConfig?.emailAuthUsed <= 0
                ? t('请提升验证邮箱授权数量')
                : ''
            }
          >
            <Button
              type={'primary'}
              onClick={async () => {
                try {
                  setTargetVisible(true)
                  setTotal(0)
                  await getTargetDomain()
                  await getGroupList({})
                  await getTotal().then(res => setTotal(res.data.total))
                } catch (error) {}
              }}
              disabled={authorizeConfig?.emailAuthTotal - authorizeConfig?.emailAuthUsed <= 0}
            >
              {t('添加评估目标')}
            </Button>
          </Tooltip>
          <Tooltip
            title={isPause && t('当前时间属于任务暂停时间段，无法创建任务')}
            placement="topRight"
          >
            <Button
              type={'primary'}
              onClick={form.submit}
              disabled={inputValue === '' || target.length === 0 || isPause}
            >
              {t('下一步')}
            </Button>
          </Tooltip>
        </Space>
      </div>
    </ModalContent>
  )
}

/**创建任务第二步任务类型 */
const TaskType = () => {
  const { dispatch, data } = useCreateTaskContext()
  const { submitData } = data
  const { setSteps, setSubmitData } = dispatch

  const [form] = useForm()
  // const [step, setStep] = useState<0 | 1>(submitData?.taskType)
  const [step, setStep] = useState(submitData?.taskType || 0)
  const [stmpId, setStmpId] = useState(submitData?.smtp_id || '')
  const [stmpUrl, setStmpUrl] = useState(submitData?.smtp_url || '')

  const clickHandler = (type: 0 | 1) => () => {
    setSubmitData(origin => ({
      ...origin,
      taskType: type,
      smtp_id: stmpId,
      smtp_url: stmpUrl,
    }))
    setSteps(3)
  }
  const handlerOnFinish = () => {
    clickHandler(step)()
  }

  const [smtpList, getSmtpList] = useGetCampaignSmtp()

  useEffect(() => {
    getSmtpList({ email_type: step == 0 ? '恶意附件' : '钓鱼链接' }).catch(_ => {})
    if (submitData?.taskType !== step) {
      // 第一次进和切换到非保存step
      form.setFieldValue('send_add', smtpList?.filter(item => item)[0].email)
      setStmpUrl(smtpList?.filter(item => item)[0].email)
      setStmpId(smtpList?.filter(item => item)[0].id)
    }
  }, [step, smtpList?.filter(item => item)[0].email, smtpList?.filter(item => item)[0].id])

  return (
    <ModalContent>
      <div className="body">
        <Form
          form={form}
          layout={'vertical'}
          name="taskType"
          onFinish={handlerOnFinish}
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <Form.Item style={{ padding: '20px 130px' }} name="task_tp">
            <Row justify={'space-between'}>
              <Col span={11}>
                <TaskTypeItemContainer
                  onClick={() => {
                    setStep(0)
                    setSubmitData(origin => ({
                      ...origin,
                      selectEmailTemplate: { page: 1, limit: 99999 },
                    }))
                    form.setFieldsValue({
                      send_add: step === submitData?.taskType ? stmpUrl : submitData?.smtp_url,
                    })
                    setStmpUrl(step === submitData?.taskType ? stmpUrl : submitData?.smtp_url)
                    setStmpId(step === submitData?.taskType ? stmpId : submitData?.smtp_id)
                  }}
                  active={step === 0}
                >
                  <TaskTypeItemFolder>
                    <IconFont type="icon-wenjianleixing-biaozhuntu-wenjianjia" />
                    <IconFont type="icon-bug" className="icon" />
                  </TaskTypeItemFolder>
                  <div className="text">{t('恶意附件')}</div>
                </TaskTypeItemContainer>
              </Col>
              <Col span={11}>
                <TaskTypeItemContainer
                  onClick={() => {
                    setStep(1)
                    setSubmitData(origin => ({
                      ...origin,
                      selectEmailTemplate: { page: 1, limit: 99999 },
                      // smtp_url: '',
                    }))
                    form.setFieldsValue({
                      send_add: step === submitData?.taskType ? stmpUrl : submitData?.smtp_url,
                    })
                    setStmpUrl(step === submitData?.taskType ? stmpUrl : submitData?.smtp_url)
                    setStmpId(step === submitData?.taskType ? stmpId : submitData?.smtp_id)
                  }}
                  active={step === 1}
                >
                  <TaskTypeItemFolder>
                    <SvgIcon name={'phishing'} style={{ width: '100px', height: '100px' }} />
                    <IconFont type="icon-youqinglianjie-lianjie" className="icon" />
                  </TaskTypeItemFolder>
                  <div className="text">{t('钓鱼链接')}</div>
                </TaskTypeItemContainer>
              </Col>
            </Row>
            {/* <TaskTypeItem /> */}
          </Form.Item>
          <div className="send-wrapper">
            <div style={{ padding: 16, display: 'flex' }}>
              <div
                style={{ display: 'flex', flexDirection: 'column', width: '30%', paddingRight: 24 }}
              >
                <div style={{ marginBottom: 8 }}>
                  <span style={{ color: '#F53F3F' }}>*</span>
                  <span>{t('发件地址')}</span>
                </div>
                <Form.Item
                  rules={[
                    {
                      validator(_, value) {
                        if (stmpUrl == null || stmpUrl == '') {
                          return Promise.reject(new Error(t('请选择发件地址')))
                        }
                        return Promise.resolve()
                      },
                    },
                  ]}
                  name="send_add"
                  style={{ width: '100%' }}
                >
                  <Select
                    defaultValue={submitData?.smtp_url}
                    style={{ width: '100%' }}
                    onChange={e => {
                      setStmpId(e)
                      setStmpUrl(smtpList?.filter(item => item.id == e)[0]?.email)
                    }}
                    optionLabelProp="label"
                    // options={smtpList?.map(item => ({ label: item.email, value: item.id }))}
                  >
                    {smtpList?.map((item, index) => (
                      <Select.Option label={item.email} value={item.id} key={index}>
                        {`${index === 0 ? t('默认') : t('自定义')}-${item.email}`}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              <div style={{ width: 1, height: 64, border: '1px solid #DFDFDF' }} />
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  paddingLeft: 24,
                }}
              >
                <div style={{ marginBottom: 8 }}>
                  <span>{t('发件服务器')}</span>
                  <span style={{ color: '#999999', fontSize: 12 }}>
                    {t('（为确保您的员工能收到电子邮件，请将发件服务器加入邮件网关白名单策略中）')}
                  </span>
                </div>
                <div style={{ paddingTop: 10 }}>
                  {smtpList?.filter(item => item.id == stmpId)[0]?.send_server ||
                    smtpList?.filter(item => item)[0].send_server ||
                    '-'}
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <div className="footer">
        <ArticleSteps currentNum={1} length={6} />
        <Space>
          <Button
            onClick={() => {
              setSteps(origin => origin - 1)
            }}
          >
            {t('上一步')}
          </Button>
          <Button
            type={'primary'}
            disabled={step !== 0 && step !== 1}
            onClick={() => {
              // clickHandler(step)()
              // setSteps(3)
              form.submit()
            }}
          >
            {t('下一步')}
          </Button>
        </Space>
      </div>
    </ModalContent>
  )
}

/**第三步邮件模版 */
const TempalteAssets = () => {
  const [form] = useForm()
  const { dispatch, data } = useCreateTaskContext()
  const {
    submitData: { selectEmailTemplate, taskType },
  } = data
  const { setSteps, setSubmitData } = dispatch
  const [getEmailTemplateParams, setGetEmailTemplateParams] = useState({
    page: selectEmailTemplate.page,
    limit: selectEmailTemplate.limit,
    email_type: taskType ? 1 : 2,
    name: '',
  })
  const [emailList, setEmailList] = useState([])
  const [availableStatus] = useCheckAvailableStatus()
  const [visible, setVisible] = useState(false)
  const [getEmailTemplate] = useGetEmailTemplate({
    getEmailTemplateParams,
  })
  const [emailTemplate, setEmailTemplate] = useState({ items: [], total: 0 })
  const [generateTemplateId, setGenerateTemplateId] = useState('')
  const [getEmailDetail, emailLoading] = useGetEmailDetail()
  const [getAiEmailTemplate, searchLoading] = useGetAiEmailTemplate()
  const [emailTemplateList, setEmailTemplateList] = useState([])
  const [createAiEmailTemplate, submitLoading] = useCreateAiEmailTemplate()
  const [getPhishingParams, setGetPhishingParams] = useState({
    limit: 9999999,
    page: 1,
    name: '',
  })
  const [getPhishingPages, getPhishing] = useGetPhishingPages({
    GetPhishingParams: getPhishingParams,
  })
  const [getAttachments, getAttachmentsList] = useGetAttachments2({
    GetAttachmentsParams: getPhishingParams,
  })
  const templateKeys = useMemo(
    () => (emailTemplate?.items || [])?.map((item: { id: any }) => item?.id),
    [emailTemplate],
  )
  useEffect(() => {
    getTemplateListFn('', false)
  }, [getEmailTemplateParams])

  useEffect(() => {
    if (emailTemplate?.items?.length > 0) {
      let arr = []
      emailTemplate?.items?.map((item: any) => {
        arr.push(item)
      })
      setEmailList(arr)
    }
  }, [emailTemplate])
  const { selected, isSelected, setSelected } = useSelections(
    templateKeys,
    selectEmailTemplate.select?.id ? [selectEmailTemplate.select?.id] : [],
  )

  const getTemplateListFn = (id, createAi) => {
    getEmailTemplate()
      .then(res => {
        console.log('res11111', res, generateTemplateId)
        const initData = JSON.parse(JSON.stringify(res?.data?.items))
        const generateItem = initData?.find(item => item.id === id)
        if (generateItem) {
          const index = initData?.indexOf(generateItem)
          initData.splice(index, 1)
          initData.unshift(generateItem)
        }
        setEmailTemplate({ items: initData, total: res?.data?.total })
        console.log('createAi', createAi)
        // 默认选中第一个模板
        if (!createAi && selectEmailTemplate?.select?.id) return

        if (initData?.length > 0) {
          const template = initData?.[0] || {}
          selectFirstTemplate(template)
        }
      })
      .catch(_ => {})
  }

  const selectFirstTemplate = template => {
    setSelected([template.id])
    getEmailDetail({ id: template.id })
      .then(res => {
        setSubmitData(origin => ({
          ...origin,
          selectEmailTemplate: {
            ...origin?.selectEmailTemplate,
            content: res?.data,
          },
        }))
      })
      .catch(err => {})
    setSubmitData(origin => ({
      ...origin,
      selectEmailTemplate: {
        limit: getEmailTemplateParams.limit,
        page: 1,
        select: template,
        email_cover: template?.cover,
        email_name: template?.name,
        email_sender: template?.sender,
        email_from: template?.origin_type,
        email_id: template?.id,
        email_link: template?.link,
      },
    }))
  }

  const submitHandler = () => {
    setSubmitData(origin => ({
      ...origin,
      selectEmailTemplate: {
        ...origin.selectEmailTemplate,
      },
    }))
    setSteps(4)
  }
  const { run } = useDebounceFn(
    e => {
      console.log('e', e.target.value)
      setGetEmailTemplateParams(origin => ({
        ...origin,
        name: e.target.value,
        page: 1,
        limit: 99999,
      }))
      setEmailList([])
    },
    {
      wait: 500,
    },
  )
  return (
    <ModalContent>
      <div className="body">
        <Form onFinish={submitHandler} form={form} style={{ width: '100%', paddingBottom: '40px' }}>
          <div style={{ width: '100%', justifyContent: 'space-between', display: 'flex' }}>
            <SearchInput
              style={{ width: '260px', marginBottom: 16 }}
              inputProps={{
                placeholder: t('请输入模板名称'),
                onChange: e => {
                  run(e)
                },
              }}
            />

            <Button
              type="primary"
              className="ai-btn"
              style={{
                marginLeft: 16,
                background: 'linear-gradient( 174deg, #2090A8 0%, #4F4FAE 100%)',
                border: 'none',
                display: 'flex',
                alignItems: 'center',
                opacity: availableStatus?.status === 'AvailableStatusTrue' ? 1 : 0.5,
                cursor:
                  availableStatus?.status === 'AvailableStatusTrue' ? 'pointer' : 'not-allowed',
              }}
              onClick={() => {
                if (availableStatus?.status !== 'AvailableStatusTrue') return
                setVisible(true)
              }}
            >
              <SvgIcon name="AI" width={'16px'} height={'16px'} style={{ marginRight: '8px' }} />
              {t('AI生成邮件')}
            </Button>
          </div>

          <Form.Item required name={'email-template'} style={{ height: '90%' }}>
            <Scrollbars
              onScroll={(e: {
                target: { clientHeight: any; scrollTop: any; scrollHeight: number }
              }) => {
                if (
                  e.target.clientHeight + e.target.scrollTop + 40 > e.target.scrollHeight &&
                  emailList?.length === getEmailTemplateParams.limit * getEmailTemplateParams.page
                ) {
                  setGetEmailTemplateParams(origin => ({
                    ...origin,
                    limit: getEmailTemplateParams.limit,
                    page: getEmailTemplateParams.page + 1,
                  }))
                }
              }}
            >
              <TemplateItemList>
                {emailList.length > 0 &&
                  emailList?.map(template => (
                    <TemplateItem
                      onClick={() => {
                        console.log(template)
                        selectFirstTemplate(template)
                      }}
                      key={template.id}
                      title={t('邮件模板')}
                      active={isSelected(template.id)}
                      cover={template.cover}
                      name={template.name}
                      sender={template.sender}
                      subject={template.subject}
                      template_type={template.origin_type}
                      type={taskType}
                    />
                  ))}
              </TemplateItemList>
            </Scrollbars>
          </Form.Item>
        </Form>
      </div>

      <AiMailModal
        visible={visible}
        modalType={'1'}
        selectEmailType={taskType === 0 ? 'EmailTypeAttachment' : 'EmailTypeLink'}
        placeholder={t('请输入邮件主题描述，如：五一假期礼品领取')}
        onConfirm={(values, handleSuccess) => {
          console.log('onConfirm', values)
          const { name, subject, sender, templateId, link } = values
          const cover = '/static/default/phishPage.png'
          const content = JSON.parse(localStorage.getItem('aiEmailText'))?.content || ''
          createAiEmailTemplate({
            name,
            subject,
            sender,
            content,
            cover,
            templateId,
            link,
            emailType: taskType === 0 ? 'EmailTypeAttachment' : 'EmailTypeLink',
          })
            .then(res => {
              console.log('res', res)
              setGenerateTemplateId(res.data.id)
              getTemplateListFn(res.data.id, true)
              handleSuccess()
              setVisible(false)
            })
            .catch(_ => {})
        }}
        inputSearch={e => {
          // taskType 0 恶意附件 1 钓鱼链接
          getAiEmailTemplate({
            subject: e,
            emailType: taskType === 0 ? 'EmailTypeAttachment' : 'EmailTypeLink',
          })
            .then(res => {
              console.log('res111', res)
              setEmailTemplateList(
                res.data.list.map((item, index) => ({ ...item, id: index })) || [],
              )
            })
            .catch(_ => {})
        }}
        submitLoading={submitLoading}
        searchLoading={searchLoading}
        onCancel={() => {
          setVisible(false)
          localStorage.removeItem('aiEmailText')
          setEmailTemplateList([])
        }}
        getPhishing={getPhishing}
        getAttachmentsList={getAttachmentsList}
        templateList={emailTemplateList || []}
      />

      <div className="footer">
        <ArticleSteps currentNum={2} length={6} />
        <Space>
          <Button
            onClick={() => {
              setSteps(origin => origin - 1)
            }}
          >
            {t('上一步')}
          </Button>
          <Button
            type={'primary'}
            onClick={form.submit}
            disabled={selected.length === 0}
            loading={emailLoading}
          >
            {t('下一步')}
          </Button>
        </Space>
      </div>
    </ModalContent>
  )
}

/**第四步编辑邮件内容 */
const EditEmail = () => {
  const [form] = useForm()
  const { dispatch, data } = useCreateTaskContext()
  const {
    isCompress,
    password,
    submitData: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      selectEmailTemplate: { select, content, email_cover, email_name, email_id, email_link },
      taskType,
      editEmail,
    },
  } = data
  const { setIsCompress, setSteps, setSubmitData, setPassword } = dispatch
  const [element, setElement] = useState<HTMLDivElement | null>(null)
  const [encryption, setEncryption] = useState(false)
  const { editor, status } = useCheditor({
    height: 300,
    initData:
      JSON.parse(localStorage.getItem('emailText'))?.id === select?.id &&
      JSON.parse(localStorage.getItem('emailText'))?.type === taskType
        ? JSON.parse(localStorage.getItem('emailText'))?.text
        : content?.content,
    element,
    onChange: e => {
      localStorage.setItem(
        'emailText',
        JSON.stringify({
          text: e,
          id:
            JSON.parse(localStorage.getItem('emailText'))?.id === select?.id &&
            JSON.parse(localStorage.getItem('emailText'))?.type === taskType
              ? JSON.parse(localStorage.getItem('emailText'))?.id
              : select?.id,
          title:
            JSON.parse(localStorage.getItem('emailText'))?.id === select?.id &&
            JSON.parse(localStorage.getItem('emailText'))?.type === taskType
              ? JSON.parse(localStorage.getItem('emailText'))?.title
              : content?.subject,
          sender:
            JSON.parse(localStorage.getItem('emailText'))?.id === select?.id &&
            JSON.parse(localStorage.getItem('emailText'))?.type === taskType
              ? JSON.parse(localStorage.getItem('emailText'))?.sender
              : content?.sender,
          type:
            JSON.parse(localStorage.getItem('emailText'))?.id === select?.id &&
            JSON.parse(localStorage.getItem('emailText'))?.type === taskType
              ? JSON.parse(localStorage.getItem('emailText'))?.type
              : taskType,
        }),
      )
      run(e)
    },
  })
  useEffect(() => {
    form.setFieldsValue({ compress: editEmail?.compress })
  }, [editEmail?.compress])
  const submitHandler = (values: any) => {
    // console.log(values)
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { sender, email_title, compress } = values
    if (!password && encryption) {
      Message.info({
        type: 'info',
        content: t('请输入压缩密码'),
        className: 'info',
        icon: <IconFont type={'icon-tishi1'} style={{ color: '#5890FF' }} />,
      })
      return
    }
    // const reg=//
    if (status === 'ready') {
      setSubmitData(origin => ({
        ...origin,
        editEmail: {
          title: values['email-title'],
          content: editor.getData(),
          template_id: content?.template_id || '',
          email_cover: email_cover || '',
          email_name: email_name || '',
          email_id: email_id || '',
          email_sender: sender || '',
          email_subject: email_title || '',
          email_link: email_link || null,
          compress: password,
        },
      }))
    } else {
      setSubmitData(origin => ({
        ...origin,
        editEmail: {
          title: values['email-title'],
          content: content?.content,
          template_id: content?.template_id || '',
          email_link: email_link || null,
          email_id: email_id || '',
          email_cover: email_cover || '',
          email_name: email_name || '',
          email_sender: sender || '',
          email_subject: email_title || '',
          compress: password,
        },
      }))
    }
    localStorage.setItem(
      'emailText',
      JSON.stringify({
        text:
          JSON.parse(localStorage.getItem('emailText'))?.id === select?.id &&
          JSON.parse(localStorage.getItem('emailText'))?.type === taskType
            ? JSON.parse(localStorage.getItem('emailText'))?.text
            : content?.content,
        id:
          JSON.parse(localStorage.getItem('emailText'))?.id === select?.id &&
          JSON.parse(localStorage.getItem('emailText'))?.type === taskType
            ? JSON.parse(localStorage.getItem('emailText'))?.id
            : select?.id,
        title:
          JSON.parse(localStorage.getItem('emailText'))?.id === select?.id &&
          JSON.parse(localStorage.getItem('emailText'))?.type === taskType
            ? JSON.parse(localStorage.getItem('emailText'))?.title
            : content?.subject,
        sender:
          JSON.parse(localStorage.getItem('emailText'))?.id === select?.id &&
          JSON.parse(localStorage.getItem('emailText'))?.type === taskType
            ? JSON.parse(localStorage.getItem('emailText'))?.sender
            : content?.sender,
        type:
          JSON.parse(localStorage.getItem('emailText'))?.id === select?.id &&
          JSON.parse(localStorage.getItem('emailText'))?.type === taskType
            ? JSON.parse(localStorage.getItem('emailText'))?.type
            : taskType,
      }),
    )
    setSteps(5)
  }
  const { run } = useDebounceFn(
    value => {
      let reg = RegExp(/{{.ZipPwd}}/)
      setEncryption(reg.test(value))
    },
    {
      wait: 500,
    },
  )
  return (
    <ModalContent>
      <div className="body">
        <Scrollbars>
          <Form
            layout={'vertical'}
            form={form}
            onFinish={submitHandler}
            initialValues={{
              email_title:
                JSON.parse(localStorage.getItem('emailText'))?.id === select?.id
                  ? JSON.parse(localStorage.getItem('emailText'))?.title
                  : content?.subject,
              sender:
                JSON.parse(localStorage.getItem('emailText'))?.id === select?.id
                  ? JSON.parse(localStorage.getItem('emailText'))?.sender
                  : content?.sender,
            }}
            style={{ paddingRight: '10px' }}
          >
            <Form.Item
              label={t('发件昵称')}
              name={'sender'}
              rules={[{ max: 64, message: t('发件昵称最多64个字') }]}
              style={{ width: '40%' }}
            >
              <Input
                placeholder={t('请输入发件昵称')}
                onChange={e => {
                  if (
                    e.target.value !== JSON.parse(localStorage.getItem('emailText'))?.text &&
                    e.target.value !== ''
                  ) {
                    localStorage.setItem(
                      'emailText',
                      JSON.stringify({
                        text:
                          JSON.parse(localStorage.getItem('emailText'))?.id === select?.id &&
                          JSON.parse(localStorage.getItem('emailText'))?.type === taskType
                            ? JSON.parse(localStorage.getItem('emailText'))?.text
                            : content?.content,
                        id:
                          JSON.parse(localStorage.getItem('emailText'))?.id === select?.id &&
                          JSON.parse(localStorage.getItem('emailText'))?.type === taskType
                            ? JSON.parse(localStorage.getItem('emailText'))?.id
                            : select?.id,
                        title:
                          JSON.parse(localStorage.getItem('emailText'))?.id === select?.id &&
                          JSON.parse(localStorage.getItem('emailText'))?.type === taskType
                            ? JSON.parse(localStorage.getItem('emailText'))?.title
                            : content?.subject,
                        sender: e.target.value,
                        type:
                          JSON.parse(localStorage.getItem('emailText'))?.id === select?.id &&
                          JSON.parse(localStorage.getItem('emailText'))?.type === taskType
                            ? JSON.parse(localStorage.getItem('emailText'))?.type
                            : taskType,
                      }),
                    )
                  }
                }}
              />
            </Form.Item>
            <Form.Item label={t('邮件主题')} name={'email_title'} style={{ width: '40%' }}>
              <Input
                placeholder={t('请输入邮件主题')}
                onChange={e => {
                  if (
                    e.target.value !== JSON.parse(localStorage.getItem('emailText'))?.text &&
                    e.target.value !== ''
                  ) {
                    localStorage.setItem(
                      'emailText',
                      JSON.stringify({
                        text:
                          JSON.parse(localStorage.getItem('emailText'))?.id === select?.id &&
                          JSON.parse(localStorage.getItem('emailText'))?.type === taskType
                            ? JSON.parse(localStorage.getItem('emailText'))?.text
                            : content?.content,
                        id:
                          JSON.parse(localStorage.getItem('emailText'))?.id === select?.id &&
                          JSON.parse(localStorage.getItem('emailText'))?.type === taskType
                            ? JSON.parse(localStorage.getItem('emailText'))?.id
                            : select?.id,
                        title: e.target.value,
                        sender:
                          JSON.parse(localStorage.getItem('emailText'))?.id === select?.id &&
                          JSON.parse(localStorage.getItem('emailText'))?.type === taskType
                            ? JSON.parse(localStorage.getItem('emailText'))?.sender
                            : select?.sender,
                        type:
                          JSON.parse(localStorage.getItem('emailText'))?.id === select?.id &&
                          JSON.parse(localStorage.getItem('emailText'))?.type === taskType
                            ? JSON.parse(localStorage.getItem('emailText'))?.type
                            : taskType,
                      }),
                    )
                  }
                }}
              />
            </Form.Item>
            <div ref={setElement} />
          </Form>
        </Scrollbars>
      </div>
      <div>
        <Form layout={'vertical'} form={form} onFinish={submitHandler}>
          {taskType === 0 && (
            <div style={{ background: '#F7F8FA', borderRadius: 8, padding: '16px 24px' }}>
              <Form.Item
                label={t('附件压缩加密方式')}
                style={{ width: 246, margin: 0 }}
                name="compress"
              >
                <div style={{ marginBottom: '20px' }}>
                  <span>{t('压缩：')}</span>
                  <Switch
                    checkedChildren={t('开')}
                    unCheckedChildren={t('关')}
                    checked={isCompress}
                    onChange={e => {
                      setIsCompress(e)
                      setPassword('')
                    }}
                  />
                </div>
                {isCompress && (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Checkbox defaultChecked disabled />
                    <span style={{ marginLeft: '3px', marginRight: '24px' }}>zip</span>
                    <span style={{ flexShrink: '0' }} className="encryption">
                      {t('加密：')}
                    </span>
                    <Input
                      maxLength={20}
                      placeholder={t('请输入密码')}
                      disabled={!encryption}
                      style={{ width: '246px', flexShrink: '0' }}
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                    />
                  </div>
                )}
              </Form.Item>
            </div>
          )}
        </Form>
        <div className="footer" style={{ marginTop: 16 }}>
          <ArticleSteps currentNum={3} length={6} />
          <Space>
            <Button
              onClick={() => {
                setSteps(origin => origin - 1)
              }}
            >
              {t('上一步')}
            </Button>
            <Button type={'primary'} onClick={form.submit}>
              {t('下一步')}
            </Button>
          </Space>
        </div>
      </div>
    </ModalContent>
  )
}

/**第五步附件模版 */
const OfficeTemplate = () => {
  const { dispatch, data } = useCreateTaskContext()
  const [getSecyTemplate, getSecyTemplateLoading, secyTemplate] = useGetSecyTemplate()
  const {
    submitData: { selectOfficeTemplate, editEmail },
  } = data
  const subject = editEmail?.email_subject || ''
  const [form] = useForm()
  const { setSteps, setSubmitData } = dispatch
  const [officeList, setOfficeList] = useState([])
  const [visible, setVisible] = useState(false)
  const [getOfficeTemplateParams, setGetOfficeTemplateParams] = useState<GetAttachments>({
    limit: selectOfficeTemplate.limit,
    page: selectOfficeTemplate.page,
    template_id: editEmail?.template_id,
    name: '',
  })
  const [officeTemplate, getOffice] = useGetAttachments({ getOfficeTemplateParams })
  const [getAiPhishingPageTemplate, searchLoading] = useGetAiPhishingPageTemplate()
  const [createAiPhishingPageTemplate, submitLoading] = useCreateAiPhishingPageTemplate()
  const [availableStatus] = useCheckAvailableStatus()
  const officeTemplateKeys = useMemo(
    () => officeTemplate.items.map((item: { id: any }) => item.id),
    [officeTemplate],
  )
  const optimumList = useMemo(() => {
    let arr = officeList?.filter(item => item.id === editEmail?.template_id)

    return arr
  }, [officeList])

  const defaultList = useMemo(() => {
    let arr = []
    officeList.map(item => {
      if (item.id !== editEmail?.template_id) {
        arr.push(item)
      }
    })

    return arr
  }, [officeList])

  useEffect(() => {
    if (selectOfficeTemplate?.select?.id) return
    if (optimumList.length > 0) {
      const item = optimumList[0]
      setSelected([item?.id])
      setFileName({ name: item.attachment_name, type: item.origin_type })
      setSubmitData(origin => ({
        ...origin,
        selectOfficeTemplate: {
          limit: getOfficeTemplateParams.limit,
          page: 1,
          select: item,
          fileName: item.attachment_name?.substring(0, item.attachment_name?.lastIndexOf('.')),
        },
      }))
      return
    }
    if (defaultList?.length > 0) {
      const item = defaultList[0]
      setSelected([item?.id])
      setFileName({ name: item.attachment_name, type: item.origin_type })
      setSubmitData(origin => ({
        ...origin,
        selectOfficeTemplate: {
          limit: getOfficeTemplateParams.limit,
          page: 1,
          select: item,
          fileName: item.attachment_name?.substring(0, item.attachment_name?.lastIndexOf('.')),
        },
      }))
    }
  }, [optimumList, defaultList])

  useEffect(() => {
    if (officeTemplate?.items?.length > 0) {
      let arr = []
      officeList?.map(item => {
        arr.push(item)
      })
      officeTemplate?.items?.map((item: any) => {
        arr.push(item)
      })
      setOfficeList(arr)
    }
  }, [officeTemplate])
  const { selected, isSelected, setSelected } = useSelections(
    officeTemplateKeys,
    selectOfficeTemplate.select?.id ? [selectOfficeTemplate.select?.id] : [],
  )
  const submitHandler = values => {
    setSubmitData(origin => ({
      ...origin,
      is_secy: radioValue == 1,
      is_commit_data: true,
      selectOfficeTemplate: {
        ...origin.selectOfficeTemplate,
        limit: getOfficeTemplateParams.limit,
        page: getOfficeTemplateParams.page,
        redirect: values.redirect,
        fileName: fileName.name,
        radioVal: radioValue,
        secyUrl: secyUrl,
        secyId: secyId,
      },
    }))
    setSteps(6)
  }
  const [isCommitData, setIsCommitData] = useState(true)
  const [isEditGroupName, setIsEditGroupName] = useState(false)
  const [radioValue, setRadioValue] = useState<number>(selectOfficeTemplate?.radioVal || 0)
  const [secyUrl, setSecyUrl] = useState(selectOfficeTemplate?.secyUrl || '')
  const [secyId, setSecyId] = useState(selectOfficeTemplate?.secyId || '')
  const [fileName, setFileName] = useState({ name: '', type: null })
  const [putAttachmentName] = usePutAttachmentName()
  const inputContentRef = useRef('')
  useEffect(() => {
    if (selectOfficeTemplate?.fileName) {
      setFileName({
        name: selectOfficeTemplate?.fileName,
        type: selectOfficeTemplate?.select.origin_type,
      })
    }
    if (selectOfficeTemplate.redirect) {
      form.setFieldsValue({ redirect: selectOfficeTemplate.redirect })
    }
    if (selectOfficeTemplate?.radioVal) {
      setRadioValue(selectOfficeTemplate?.radioVal)
    }
  }, [selectOfficeTemplate?.select, selectOfficeTemplate.redirect])
  useEffect(() => {
    getSecyTemplate({ limit: 9999, page: 1, keyword: '' }).catch(_ => {})
  }, [])
  const [suffix, setSuffix] = useState(selectOfficeTemplate?.suffix || null)
  const [emailPageTemplateList, setEmailPageTemplateList] = useState([])

  const { run } = useDebounceFn(
    e => {
      setGetOfficeTemplateParams(origin => ({
        ...origin,
        name: e.target.value,
        page: 1,
      }))
      setOfficeList([])
    },
    {
      wait: 500,
    },
  )

  return (
    <ModalContent>
      <div className="body">
        <Form
          layout={'vertical'}
          onFinish={submitHandler}
          form={form}
          style={{ width: '100%', paddingBottom: '0px' }}
          initialValues={{ redirect: 'https://' }}
        >
          <div style={{ width: '100%', justifyContent: 'space-between', display: 'flex' }}>
            <SearchInput
              style={{ width: '260px', marginBottom: 16 }}
              inputProps={{
                placeholder: t('附件名称'),
                onChange: e => {
                  run(e)
                },
              }}
            />

            {/* <Button
               type="primary"
               style={{
                 marginLeft: 16,
                 background: 'linear-gradient( 174deg, #2090A8 0%, #4F4FAE 100%)',
                 border: 'none',
               }}
               onClick={() => {
                 setVisible(true)
               }}
               disabled={availableStatus?.status !== 'AvailableStatusTrue'}
              >
               AI生成钓鱼页
              </Button> */}
          </div>

          <Form.Item
            name={'office-template'}
            rules={[
              {
                validator: async () => {
                  if (!selectOfficeTemplate.select) {
                    Message.error(t('请选择附件模板'))
                    throw new Error('')
                  }
                },
              },
            ]}
            style={{ height: 'calc(100% - 225px)', marginBottom: 16 }}
          >
            <Scrollbars
              onScroll={(e: {
                target: { clientHeight: any; scrollTop: any; scrollHeight: number }
              }) => {
                if (
                  e.target.clientHeight + e.target.scrollTop + 40 > e.target.scrollHeight &&
                  officeList?.length ===
                    getOfficeTemplateParams.limit * getOfficeTemplateParams.page
                ) {
                  setGetOfficeTemplateParams(origin => ({
                    ...origin,
                    limit: getOfficeTemplateParams.limit,
                    page: getOfficeTemplateParams.page + 1,
                  }))
                }
              }}
            >
              <TemplateItemList>
                {optimumList?.map(item => (
                  <TemplateItem
                    key={item.id}
                    cover={item.cover}
                    name={item.attachment_name}
                    optimum
                    title={t('附件模板')}
                    template_type={item.origin_type}
                    type={item.attachment_type}
                    active={isSelected(item.id)}
                    onClick={() => {
                      if (isSelected(item.id)) {
                        setSelected([])
                        setFileName({ name: null, type: null })
                        setSubmitData(origin => ({
                          ...origin,
                          selectOfficeTemplate: {
                            limit: getOfficeTemplateParams.limit,
                            page: getOfficeTemplateParams.page,
                            select: null,
                            fileName: null,
                          },
                        }))
                      } else {
                        setSelected([item.id])
                        setFileName({ name: item.attachment_name, type: item.origin_type })
                        setSubmitData(origin => ({
                          ...origin,
                          selectOfficeTemplate: {
                            limit: getOfficeTemplateParams.limit,
                            page: 1,
                            select: item,
                            fileName: item.attachment_name?.substring(
                              0,
                              item.attachment_name?.lastIndexOf('.'),
                            ),
                          },
                        }))
                      }
                    }}
                  />
                ))}
                {defaultList?.map(item => (
                  <TemplateItem
                    key={item.id}
                    cover={item.cover}
                    name={item.name}
                    title={t('附件模板')}
                    template_type={item.origin_type}
                    type={item.attachment_type}
                    accessory_type={item.attachment_name}
                    active={isSelected(item.id)}
                    onClick={() => {
                      setRadioValue(0)
                      form.setFieldValue('secy', null)
                      form.setFieldsValue({
                        redirect:
                          item.redirect && item.redirect !== '' ? item.redirect : 'https://',
                      })
                      if (isSelected(item.id)) {
                        setSelected([])
                        setFileName({ name: null, type: null })
                        setSubmitData(origin => ({
                          ...origin,
                          selectOfficeTemplate: {
                            limit: getOfficeTemplateParams.limit,
                            page: getOfficeTemplateParams.page,
                            select: null,
                            fileName: null,
                          },
                        }))
                        setSuffix(null)
                      } else {
                        setSelected([item.id])
                        setSuffix(
                          item.attachment_name?.substring(item.attachment_name?.lastIndexOf('.')),
                        )
                        setSubmitData(origin => ({
                          ...origin,
                          selectOfficeTemplate: {
                            limit: getOfficeTemplateParams.limit,
                            page: getOfficeTemplateParams.page,
                            select: item,
                            suffix: item.attachment_name?.substring(
                              item.attachment_name?.lastIndexOf('.'),
                            ),
                            fileName: item.attachment_name?.substring(
                              0,
                              item.attachment_name?.lastIndexOf('.'),
                            ),
                          },
                        }))
                      }
                    }}
                  />
                ))}
              </TemplateItemList>
            </Scrollbars>
          </Form.Item>
          <div style={{ display: 'flex', marginTop: 25 }} className="redirect-wrapper">
            {selectOfficeTemplate?.select && (
              <>
                <div style={{ width: 270 }}>
                  <div>{t('附件名称')}</div>
                  <div className="attachment">
                    {isEditGroupName ? (
                      <div className="flex">
                        <Input
                          placeholder={t('请输入')}
                          defaultValue={fileName.name}
                          onChange={e => {
                            inputContentRef.current = e.target.value
                          }}
                        />

                        <CloseCircleOutlined
                          style={{ marginLeft: 12 }}
                          onClick={() => {
                            setIsEditGroupName(false)
                          }}
                        />

                        <CheckCircleOutlined
                          style={{ marginLeft: 12 }}
                          onClick={async () => {
                            try {
                              if (inputContentRef.current.length > 50) {
                                Message.error(t('附件名称最多50字'))
                                return
                              }
                              setFileName(origin => ({ ...origin, name: inputContentRef.current }))
                              setIsEditGroupName(false)
                            } catch (error) {}
                          }}
                        />
                      </div>
                    ) : (
                      <div className="flex">
                        {suffix === '.exe' ? (
                          <Svg name={'mini_exe'} />
                        ) : suffix === '.pdf' ? (
                          <Svg name="mini_pdf" />
                        ) : suffix === '.docx' || suffix === '.doc' ? (
                          <Svg name="mini_docx" />
                        ) : suffix === '.xls' || suffix === '.xlsx' ? (
                          <Svg name="mini_xlsx" />
                        ) : suffix === '.rtf' ? (
                          <Svg name="mini_rtf" />
                        ) : suffix === '.pptx' || suffix === '.ppt' ? (
                          <Svg name="mini_ppt" />
                        ) : (
                          ''
                        )}

                        <Typography.Text
                          style={{ width: 300, whiteSpace: 'pre-wrap' }}
                          ellipsis={{ tooltip: true }}
                        >
                          {fileName.name}
                        </Typography.Text>
                        <IconFont
                          type="icon-huabanfuben"
                          onClick={() => {
                            setIsEditGroupName(true)
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', margin: '0 24px' }}>
                  <div style={{ height: 100, width: 1, background: '#dfdfdf' }} />
                </div>
              </>
            )}
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div>
                <span>{t('重定向页面')}</span>
                <span style={{ color: '#999999', fontSize: 12 }}>
                  {t('（可输入自定义URL或选择系统内置的安全教育模板作为重定向页面）')}
                </span>
              </div>
              <Radio.Group
                style={{ paddingTop: 12 }}
                value={radioValue}
                onChange={e => setRadioValue(e.target.value)}
              >
                <Radio value={0}>{t('输入自定义URL')}</Radio>
                <Radio
                  value={1}
                  onClick={async () => {
                    try {
                      await getSecyTemplate({ limit: 9999, page: 1, keyword: '' })
                    } catch (error) {}
                  }}
                >
                  {t('选择安全教育模板')}
                </Radio>
              </Radio.Group>
              {radioValue === 0 ? (
                <Form.Item
                  name="redirect"
                  // label={'请输入URL'}
                  style={{ width: 246, margin: 0, paddingTop: 14 }}
                  className="redirect"
                  rules={[
                    { type: 'url', message: t('URL格式效验不通过') },
                    {
                      max: 255,
                      message: t('URL长度不允许超过255个字符'),
                    },
                  ]}
                >
                  <Input placeholder="http://example.com" />
                </Form.Item>
              ) : (
                <div style={{ paddingTop: 14 }}>
                  <Form.Item name="secy" className="redirect">
                    <Select
                      showSearch
                      optionFilterProp="label"
                      placeholder={t('请选择安全教育模板')}
                      // defaultValue={selectOfficeTemplate?.secyUrl}
                      defaultValue={selectOfficeTemplate?.secyId}
                      style={{ width: 246 }}
                      options={secyTemplate?.map((item, k) => ({
                        label: `${item.name} (${item.redirect})`,
                        value: `${item.id}`,
                      }))}
                      onChange={(e, option) => {
                        setSecyUrl(option.label)
                        setSecyId(e)
                      }}
                    />
                  </Form.Item>
                </div>
              )}
            </div>
          </div>
        </Form>
      </div>
      {/* 第五步 恶意附件类型 */}
      <AiMailModal
        visible={visible}
        modalType={'2'}
        subject={subject}
        placeholder={t('请输入邮件主题描述，如：五一假期礼品领取1')}
        onConfirm={(values, handleSuccess) => {
          let { name, redirect, security_id } = values
          if (redirect) {
            if (security_id === '1') {
              console.log('---secyTemplate', secyTemplate)
              security_id = redirect
              redirect = secyTemplate?.filter(e => redirect === e.id)?.[0]?.redirect
            }
            if (
              security_id === '0' &&
              !(redirect.includes('http://') || redirect.includes('https://'))
            ) {
              redirect = `https://${redirect}`
            }
          }
          const cover = '/static/default/phishPage.png'
          const content = JSON.parse(localStorage.getItem('aiEmailText'))?.content || ''
          createAiPhishingPageTemplate({ name, content, redirect, security_id, cover })
            .then(res => {
              console.log('res', res)
              setVisible(false)
              localStorage.removeItem('aiEmailText')
              handleSuccess()
            })
            .catch(_ => {})
        }}
        inputSearch={value => {
          getAiPhishingPageTemplate({
            subject: value.subject,
            message1: value.message1 ? value.message1 : t('账号'),
            message2: value.message2 ? value.message2 : t('密码'),
          })
            .then(res => {
              setEmailPageTemplateList(
                res.data.list.map((item, index) => ({ ...item, id: index })) || [],
              )
            })
            .catch(_ => {})
        }}
        submitLoading={submitLoading}
        searchLoading={searchLoading}
        templateList={emailPageTemplateList || []}
        securityTemplateList={secyTemplate || []}
        onCancel={() => {
          setVisible(false)
          localStorage.removeItem('aiEmailText')
        }}
      />

      <div className="footer">
        <ArticleSteps currentNum={4} length={6} />
        <Space>
          <Button
            onClick={() => {
              setSteps(origin => origin - 1)
            }}
          >
            {t('上一步')}
          </Button>
          <Button
            type={'primary'}
            disabled={selected.length === 0}
            onClick={() => {
              form.submit()
            }}
          >
            {t('下一步')}
          </Button>
        </Space>
      </div>
    </ModalContent>
  )
}

// 第五步钓鱼类型
const GofishingTemplate = () => {
  const { dispatch, data } = useCreateTaskContext()
  const [getSecyTemplate, getSecyTemplateLoading, secyTemplate] = useGetSecyTemplate()
  const [createAiPhishingPageTemplate, submitLoading] = useCreateAiPhishingPageTemplate()
  const [getAiPhishingPageTemplate, searchLoading] = useGetAiPhishingPageTemplate()
  const [emailPageTemplateList, setEmailPageTemplateList] = useState([])
  const [availableStatus] = useCheckAvailableStatus()
  const [createAi, setCreateAi] = useState(false)
  const [form] = useForm()
  const {
    submitData: {
      selectFishingTemplate,
      taskType,
      selectEmailTemplate: { content },
      editEmail,
    },
  } = data
  const [secyUrl, setSecyUrl] = useState(selectFishingTemplate?.secyUrl || '')
  const [secyId, setSecyId] = useState(selectFishingTemplate?.secyId || '')
  const subject = editEmail?.email_subject || ''

  const { setSteps, setSubmitData } = dispatch
  const [getPagesParams, setGetPagesParams] = useState<GetAttachments>({
    limit: selectFishingTemplate.limit,
    page: selectFishingTemplate.page,
    template_id: content?.template_id,
    name: '',
  })
  const [radioValue, setRadioValue] = useState<number>(selectFishingTemplate?.radioVal || 0)
  const [phishingList, setPhishingList] = useState([])
  const [visible, setVisible] = useState(false)
  const [getFishingTemplate] = useGetPages({ getPagesParams })
  const [fishingTemplate, setFishingTemplate] = useState([])
  const [generateItemId, setGenerateTemplateId] = useState('')

  const fishingTemplateKeys = useMemo(
    () => fishingTemplate?.map((item: { id: any }) => item.id),
    [fishingTemplate],
  )
  useEffect(() => {
    getFishingTemplate()
      .then(res => {
        const initData = JSON.parse(JSON.stringify(res?.data?.items)) || []
        const generateItem = initData?.find(item => item.id === generateItemId)
        if (generateItem) {
          const index = initData?.indexOf(generateItem)
          initData.splice(index, 1)
          initData.unshift(generateItem)
        }
        setFishingTemplate(initData)
      })
      .catch(_ => {})
  }, [getPagesParams])
  const optimumList = useMemo(() => {
    let arr = []
    phishingList?.map(item => {
      if (item.id === editEmail?.template_id) {
        arr.push(item)
      }
    })
    return arr
  }, [phishingList])

  const defaultList = useMemo(() => {
    let arr = []
    phishingList?.map(item => {
      if (item.id !== editEmail?.template_id) {
        arr.push(item)
      }
    })
    return arr
  }, [phishingList])

  useEffect(() => {
    if (!createAi && selectFishingTemplate?.select?.id) return

    if (!generateItemId && optimumList.length > 0) {
      const item = optimumList[0]
      setSelected([item?.id])
      clickHandler(item)
      return
    }
    if (defaultList?.length > 0) {
      console.log('generateItemId', generateItemId, optimumList)
      const item = defaultList[0]
      setSelected([item?.id])
      clickHandler(item)
    }
  }, [optimumList, defaultList, createAi])
  useEffect(() => {
    if (fishingTemplate?.length > 0) {
      let arr = []
      phishingList?.map(item => {
        arr.push(item)
      })
      fishingTemplate?.map((item: any) => {
        arr.push(item)
      })
      setPhishingList(arr)
    }
  }, [fishingTemplate])
  useEffect(() => {
    getSecyTemplate({ limit: 9999, page: 1, keyword: '' }).catch(_ => {})
  }, [])
  const { selected, isSelected, setSelected } = useSelections(
    fishingTemplateKeys,
    selectFishingTemplate.select?.id ? [selectFishingTemplate.select?.id] : [],
  )
  const clickHandler = item => {
    setSelected([item.id])
    setSubmitData(origin => ({
      ...origin,
      selectFishingTemplate: {
        limit: getPagesParams.limit,
        page: getPagesParams.page,
        select: item,
      },
    }))
    if (item.security_id?.length > 1) {
      setRadioValue(1)
      setSecyId(item.security_id)
      form.setFieldValue('secy', item.security_id)
      form.setFieldValue('redirect', item.redirect)
    } else {
      setRadioValue(0)
      setSecyId(null)
      form.setFieldsValue({
        redirect: item.redirect && item.redirect !== '' ? item.redirect : 'https://',
        secy: null,
      })
    }
  }
  const submitHandler = values => {
    // console.log(values.is_commit_data)
    setSubmitData(origin => ({
      ...origin,
      is_secy: radioValue == 1,
      is_commit_data: values.is_commit_data,
      selectFishingTemplate: {
        ...origin.selectFishingTemplate,
        select: { ...selectFishingTemplate.select, redirect: values?.redirect },
        limit: 99999,
        page: 1,
        radioVal: radioValue,
        secyUrl: secyUrl,
        secyId: secyId,
      },
    }))
    setSteps(6)
  }
  useEffect(() => {
    if (
      selectFishingTemplate?.select?.redirect &&
      selectFishingTemplate?.select?.redirect == 'https://' // 安全教育模板的自定义url框内容不展示
    ) {
      form.setFieldsValue({ redirect: selectFishingTemplate?.select?.redirect })
    }
    if (selectFishingTemplate?.radioVal) {
      setRadioValue(selectFishingTemplate?.radioVal)
    }
  }, [selectFishingTemplate?.select?.redirect])
  useEffect(() => {
    if (selectFishingTemplate?.radioVal == 1 || radioValue == 1) {
      getSecyTemplate({ limit: 9999, page: 1, keyword: '' }).catch(_ => {})
    }
  }, [])
  const { run } = useDebounceFn(
    e => {
      setGetPagesParams(origin => ({ ...origin, name: e.target.value, page: 1 }))
      setPhishingList([])
    },
    {
      wait: 500,
    },
  )
  return (
    <ModalContent>
      <div className="body">
        <Form
          form={form}
          layout={'vertical'}
          onFinish={submitHandler}
          style={{ width: '100%' }}
          initialValues={{ redirect: selectFishingTemplate?.select?.redirect || 'https://' }}
        >
          <div style={{ width: '100%', justifyContent: 'space-between', display: 'flex' }}>
            <SearchInput
              style={{ width: '260px', marginBottom: 16 }}
              inputProps={{
                placeholder: t('模板名称'),
                onChange: e => {
                  run(e)
                },
              }}
            />

            <Button
              type="primary"
              className="ai-btn"
              style={{
                marginLeft: 16,
                background: 'linear-gradient( 174deg, #2090A8 0%, #4F4FAE 100%)',
                border: 'none',
                display: 'flex',
                alignItems: 'center',
                opacity: availableStatus?.status === 'AvailableStatusTrue' ? 1 : 0.5,
                cursor:
                  availableStatus?.status === 'AvailableStatusTrue' ? 'pointer' : 'not-allowed',
              }}
              onClick={() => {
                if (availableStatus?.status !== 'AvailableStatusTrue') return
                setVisible(true)
              }}
            >
              <SvgIcon name="AI" width={'16px'} height={'16px'} style={{ marginRight: '8px' }} />
              {t('AI生成钓鱼页')}
            </Button>
          </div>
          <Form.Item
            name={'ddd'}
            rules={[
              {
                validator: async () => {
                  if (!selectFishingTemplate.select && selected.length === 0) {
                    Message.error(t('请选择钓鱼页模板'))
                    throw new Error('')
                  }
                },
              },
            ]}
            style={{ height: 'calc(100% - 225px)', marginBottom: 16 }}
          >
            <Scrollbars
              onScroll={(e: {
                target: { clientHeight: any; scrollTop: any; scrollHeight: number }
              }) => {
                if (
                  e.target.clientHeight + e.target.scrollTop + 40 > e.target.scrollHeight &&
                  phishingList?.length === getPagesParams.limit * getPagesParams.page
                ) {
                  setGetPagesParams(origin => ({
                    ...origin,
                    limit: getPagesParams.limit,
                    page: getPagesParams.page + 1,
                  }))
                }
              }}
            >
              <TemplateItemList>
                {optimumList?.map(item => (
                  <TemplateItem
                    key={item.id}
                    cover={item.cover}
                    name={item.name}
                    type={taskType}
                    optimum
                    autocommit={item?.autocommit}
                    template_type={item.origin_type}
                    redirect={item.redirect || '-'}
                    title={t('钓鱼页模板')}
                    active={isSelected(item.id)}
                    onClick={() => {
                      clickHandler(item)
                    }}
                  />
                ))}
                {defaultList?.map(item => (
                  <TemplateItem
                    key={item.id}
                    cover={item.cover}
                    name={item.name}
                    type={taskType}
                    autocommit={item?.autocommit}
                    template_type={item.origin_type}
                    title={t('钓鱼页模板')}
                    redirect={item.redirect || '-'}
                    active={isSelected(item.id)}
                    onClick={() => {
                      clickHandler(item)
                    }}
                  />
                ))}
              </TemplateItemList>
            </Scrollbars>
          </Form.Item>
          <div style={{ display: 'flex', marginTop: 25 }} className="redirect-wrapper">
            {/* <Form.Item
               name="redirect"
               label={'请输入URL'}
               style={{ width: 246, margin: 0 }}
               className="redirect"
               rules={[
                 { type: 'url', message: 'URL格式效验不通过' },
                 {
                   max: 255,
                   message: 'URL长度不允许超过255个字符',
                 },
               ]}
              >
               <Input placeholder="http://example.com" />
              </Form.Item> */}
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div>
                <span>{t('重定向页面')}</span>
                <span style={{ color: '#999999', fontSize: 12 }}>
                  {t('（可输入自定义URL或选择系统内置的安全教育模板作为重定向页面）')}
                </span>
              </div>
              <Radio.Group
                style={{ paddingTop: 12 }}
                value={radioValue}
                onChange={e => {
                  setRadioValue(e.target.value)
                  form.setFieldsValue({ redirect: null, secy: null })
                }}
              >
                <Radio value={0}>{t('输入自定义URL')}</Radio>
                <Radio
                  value={1}
                  onClick={async () => {
                    try {
                      await getSecyTemplate({ limit: 9999, page: 1, keyword: '' })
                    } catch (error) {}
                  }}
                >
                  {t('选择安全教育模板')}
                </Radio>
              </Radio.Group>
              {radioValue === 0 ? (
                <Form.Item
                  name="redirect"
                  // label={'请输入URL'}
                  style={{ width: 246, margin: 0, paddingTop: 14 }}
                  className="redirect"
                  rules={[
                    { type: 'url', message: t('URL格式效验不通过') },
                    {
                      max: 255,
                      message: t('URL长度不允许超过255个字符'),
                    },
                  ]}
                >
                  <Input placeholder="http://example.com" />
                </Form.Item>
              ) : (
                <div style={{ paddingTop: 14 }}>
                  <Form.Item
                    name="secy"
                    className="redirect"
                    // rules={[
                    //   {
                    //     validator(_, value) {
                    //       if (secyUrl == '') {
                    //         return Promise.reject(new Error('请选择教育模板'))
                    //       }
                    //       return Promise.resolve()
                    //     },
                    //   },
                    // ]}
                  >
                    <Select
                      showSearch
                      optionFilterProp="label"
                      placeholder={t('请选择安全教育模板')}
                      defaultValue={selectFishingTemplate?.secyId}
                      // defaultValue={secyId}
                      style={{ width: 246 }}
                      options={secyTemplate?.map((item, k) => ({
                        label: `${item.name} (${item.redirect})`,
                        value: `${item.id}`,
                      }))}
                      onChange={(e, option) => {
                        setSecyUrl(option.label)
                        setSecyId(e)
                      }}
                    />
                  </Form.Item>
                </div>
              )}
            </div>
            <div
              style={{ width: 1, backgroundColor: '#d9d9d9', marginLeft: 20, marginRight: 23 }}
            />

            <div>
              <span>{t('记录提交数据')}</span>
              <span style={{ color: '#999999', fontSize: 12 }}>
                {t('（该配置仅对可提交数据的钓鱼页有效）')}
              </span>
              <Form.Item initialValue name="is_commit_data" valuePropName="checked">
                <Switch />
              </Form.Item>
            </div>
          </div>
        </Form>
      </div>
      {/* 第五步 钓鱼邮件类型 */}
      <AiMailModal
        visible={visible}
        modalType={'2'}
        subject={subject}
        placeholder={t('请输入邮件主题描述，如：五一假期礼品领取')}
        onConfirm={(values, handleSuccess) => {
          console.log('onConfirm', values)
          let { name, redirect, security_id } = values
          if (redirect) {
            if (security_id === '1') {
              console.log('---secyTemplate', secyTemplate)
              security_id = redirect
              redirect = secyTemplate?.filter(e => redirect === e.id)?.[0]?.redirect
            }
            if (
              security_id === '0' &&
              !(redirect.includes('http://') || redirect.includes('https://'))
            ) {
              redirect = `https://${redirect}`
            }
          }
          const cover = '/static/default/phishPage.png'
          const content = JSON.parse(localStorage.getItem('aiEmailText'))?.content || ''
          createAiPhishingPageTemplate({
            name,
            content,
            redirect,
            securityId: security_id,
            cover,
            autoCommit: 2,
          })
            .then(res => {
              console.log('res', res)
              setCreateAi(true)
              setGenerateTemplateId(res.data.id)
              setVisible(false)
              localStorage.removeItem('aiEmailText')
              setPhishingList([])
              setGetPagesParams(origin => ({ ...origin, page: 1, limit: 99999 }))
              handleSuccess()
            })
            .catch(_ => {})
        }}
        inputSearch={value => {
          getAiPhishingPageTemplate({
            subject: value.subject,
            message1: value.message1 ? value.message1 : t('账号'),
            message2: value.message2 ? value.message2 : t('密码'),
          })
            .then(res => {
              setEmailPageTemplateList(
                res.data.list.map((item, index) => ({ ...item, id: index })) || [],
              )
            })
            .catch(_ => {})
        }}
        submitLoading={submitLoading}
        searchLoading={searchLoading}
        templateList={emailPageTemplateList || []}
        securityTemplateList={secyTemplate || []}
        onCancel={() => {
          setVisible(false)
          localStorage.removeItem('aiEmailText')
        }}
      />

      <div className="footer">
        <ArticleSteps currentNum={4} length={6} />
        <Space>
          <Button
            onClick={() => {
              setSteps(origin => origin - 1)
            }}
          >
            {t('上一步')}
          </Button>
          <Button type={'primary'} onClick={form.submit} disabled={selected.length === 0}>
            {t('下一步')}
          </Button>
        </Space>
      </div>
    </ModalContent>
  )
}

/**部门选择列表 */
const AssessTarget = props => {
  const { getTarget, sub, addEmail, execute } = props
  const { dispatch, data } = useCreateTaskContext()
  const [form] = useForm()
  const { submitData } = data
  const { state }: any = useLocation()
  const [searchName, setSearchName] = useState('')
  const debounceSearchName = useDebounce(searchName, { wait: 500 })
  const [getTag, getTagList] = useGetTagList()
  const [selectedList, setSelectedList] = useState<any>()
  const [plainOptions, setPlainOptions] = useState([])
  const [plainOptionList, setPlainOptionList] = useState([])
  const [plainOptionsList, setPlainOptionsList] = useState([])
  const [getTargetList] = useGetTargetList()
  const [tagIds, setTagIds] = useState([])
  useEffect(() => {
    getTargetList({ keyword: debounceSearchName, tag_ids: tagIds })
      .then(res => {
        setPlainOptions(res?.data?.items)
        setPlainOptionList(res?.data?.items)
        let select = []
        setPlainOptionsList(res?.data?.items)
        res?.data?.items?.map(item => {
          item?.targets?.map(
            (i: {
              id: any
              name: any
              email: any
              dept_name: any
              tag_list: any
              group_id: string
            }) => {
              select.push({
                id: i.id,
                name: i.name,
                email: i.email,
                dept_name: i.dept_name,
                dept_id: i?.group_id,
                tag_list: i.tag_list,
              })
            },
          )
        })
        console.log('select', select)
        setSelectedList(select)
        // }
      })
      .catch(err => {})
  }, [debounceSearchName, addEmail, tagIds])
  const [checked, setChecked] = useState<any>(submitData.selected || [])
  const [selectList, setSelectList] = useState<any>([])
  const { setSteps, setSubmitData } = dispatch
  const [targetList, setTargetList] = useState([])
  console.log('checked', checked)
  const submitHandler = () => {
    let arr = []
    let tagList = []
    let deptList = []
    let deptIds = []
    targetList.map(
      (item: {
        id: any
        email: any
        name: any
        dept_name: string
        group_id: string
        tag_list: any[]
      }) => {
        if (mapList.has(item.id)) {
          arr.push({
            email: item.email,
            name: item?.name,
            dept_name: item.dept_name,
            tag: item.tag_list?.join(','),
            dept_id: item?.group_id,
          })
          if (deptList.some(items => items === item.dept_name)) {
          } else if (item.dept_name) {
            deptList.push(item.dept_name)
            deptIds.push(item.group_id)
          }
          item?.tag_list?.map((i: any) => {
            if (tagList.some(items => items === i)) {
              return
            }
            if (i !== '') {
              tagList.push(i)
            }
          })
        }
      },
    )
    setSubmitData(origin => ({
      ...origin,
      groups: arr,
      tagList: tagList,
      targetIds: deptIds,
      deptList: deptList,
      selected: checked,
      mapList: mapList,
    }))
  }
  useEffect(() => {
    if (sub) {
      form.submit()
    }
  }, [sub])
  const [clickSearch, setClickSearch] = useState(false)
  const [num, setNum] = useState(0)
  const [defaultList, setDefaultList] = useState([])
  const [emailList, setEmailList] = useState([])
  const [mapList, setMapList] = useState<any>(submitData.mapList || new Map())
  const [treeCount, setTreeCount] = useState(true)
  const treeData = useMemo(() => {
    let arr = []
    let n = 0
    let list = []
    let map1 = new Map()
    if (plainOptions?.length > 0) {
      plainOptions.map(item => {
        n = n + (item?.targets?.length || 0)
        if (item.targets) {
          list.push(...(item.targets || []))
        }
        if (item.id === state?.group_id && treeCount) {
          setTreeCount(false)
          item?.targets?.map(i => {
            map1.set(i.id, i.email)
          })
          setMapList(map1)
          setChecked([...map1].flat().filter(i => map1.get(i)))
          console.log('checked: ', checked)
        }
        arr.push({
          ...item,
          title: (
            <Typography.Text style={{ width: 300 }} ellipsis={{ tooltip: true }}>
              {item.name}
            </Typography.Text>
          ),

          icon: (
            <IconFont
              onClick={e => e.preventDefault()}
              type="icon-drxx27"
              style={{ margin: '0 8px', color: '#4238C9' }}
            />
          ),

          targets: item.targets?.map(e => ({
            ...e,
            title: (
              <Typography.Text style={{ width: 300 }} ellipsis={{ tooltip: true }}>
                {e.email}
              </Typography.Text>
            ),
          })),
        })
      })
    }
    setDefaultList(list.map(item => item.id))
    setNum(n)
    setEmailList(list)
    if (debounceSearchName === '') {
      // console.log('targetList:', list)
      setTargetList(list)
    }

    return arr as any
  }, [plainOptions])
  const containerRef = useRef(null)
  const wrapperRef = useRef(null)
  const [list] = useVirtualList(checked, {
    containerTarget: containerRef,
    wrapperTarget: wrapperRef,
    itemHeight: 32,
    overscan: 10,
  })
  useEffect(() => {
    getTarget(checked)
  }, [checked])
  return (
    <ModalContent>
      <div className="body">
        <div
          style={{
            width: '100%',
            height: execute === 2 ? 'calc(100% - 32px)' : '100%',
          }}
        >
          <Form
            form={form}
            onFinish={submitHandler}
            style={{
              marginRight: 20,
              height: '100%',
            }}
            layout="vertical"
          >
            <div style={{ display: 'flex', alignItems: 'flex-end', overflow: 'hidden' }}>
              <SearchInputTwo
                style={{
                  width: clickSearch ? '100%' : '152px',
                  marginRight: clickSearch ? '0' : '10px',
                }}
                inputProps={{
                  placeholder: t('部门、邮箱账号'),
                  value: searchName,
                  onFocus: () => {
                    setClickSearch(true)
                  },
                  onBlur: () => {
                    setClickSearch(false)
                  },
                  onChange: e => {
                    setSearchName(e.target.value)
                  },
                }}
              />

              <Form.Item
                name="groupList"
                // label="标签"
                style={{ width: 0, flex: 1, margin: 0, height: clickSearch && 32 }}
              >
                <Select
                  placeholder={t('请选择标签')}
                  mode="multiple"
                  showArrow
                  showSearch={false}
                  getPopupContainer={() => document.body}
                  maxTagCount={2}
                  maxTagTextLength={7}
                  onChange={(e: any) => {
                    setTagIds(e)
                  }}
                >
                  {getTagList?.map(
                    (item: {
                      id: React.Key
                      name: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal
                    }) => (
                      <Option value={item?.id} key={item?.id}>
                        {item?.name}
                      </Option>
                    ),
                  )}
                </Select>
              </Form.Item>
            </div>
            <Form.Item
              name={'select-gourp'}
              rules={[
                {
                  validator: async () => {
                    if (checked.length === 0) {
                      throw new Error(t('请选择评估目标'))
                    }
                  },
                },
              ]}
              style={{
                height: 'calc(100vh - 570px)',
                minHeight: 220,
                border: '1px solid #D9D9D9',
                borderRadius: 6,
                paddingLeft: 10,
                marginTop: 10,
                overflowY: 'scroll',
              }}
            >
              <Checkbox
                value="0"
                onChange={e => {
                  if (debounceSearchName !== '' || tagIds.length > 0) {
                    let arr = [...mapList]
                    let map4 = new Map(arr)
                    if (e.target.checked) {
                      emailList?.map(i => {
                        if (!mapList.has(i)) {
                          map4.set(i.id, i.email)
                        }
                      })
                    } else {
                      emailList?.map(i => {
                        map4.delete(i.id)
                      })
                    }
                    setMapList(map4)
                    setChecked([...map4].flat().filter((item, i) => map4.get(item)))
                    return
                  }
                  if (e.target.checked) {
                    let set = new Set(emailList.map(item => [item.id, item.email]))
                    let map4 = new Map(set)
                    setMapList(map4)
                    setSelectList(emailList)
                    setChecked([...map4].flat().filter((item, i) => map4.get(item)))
                  } else {
                    let map4 = mapList
                    emailList.map(item => map4.delete(item.id))
                    setMapList(map4)
                    setSelectList(emailList)
                    setChecked([...map4].flat().filter((item, i) => map4.get(item)))
                  }
                }}
                checked={defaultList?.length > 0 && defaultList.every(e => mapList.has(e))}
                indeterminate={checked?.length > 0 && !(checked?.length >= num)}
                style={{ marginBottom: 6, marginTop: 10, marginLeft: 6 }}
              >
                {t('全选')}
              </Checkbox>
              <Tree
                checkable
                onCheck={(e: any, d) => {
                  if (debounceSearchName !== '' || tagIds.length > 0) {
                    let arr = [...mapList]
                    let map4 = new Map(arr)
                    const node: any = d.node
                    if (d.checked) {
                      map4.set(node.id, node.email)
                      node?.targets?.map(i => {
                        map4.set(i.id, i.email)
                      })
                    } else {
                      map4.delete(node.id)
                      node?.targets?.map(i => {
                        map4.delete(i.id)
                      })
                    }
                    setMapList(map4)
                    setChecked([...map4].flat().filter((item, i) => map4.get(item)))
                    setSelectList(d.checkedNodes)
                    return
                  }
                  setSelectList(d.checkedNodes)
                  let set = new Set(d.checkedNodes.map(item => [item.id, item.email]))
                  let map4 = new Map(set)
                  setMapList(map4)
                  setChecked([...map4].flat().filter((item, i) => map4.get(item)))
                }}
                selectable={false}
                checkedKeys={checked}
                showIcon
                height={400}
                treeData={treeData}
                fieldNames={{ title: 'title', key: 'id', children: 'targets' }}
              />
            </Form.Item>
          </Form>
        </div>
        <div
          className="selected"
          style={{
            height: execute === 2 ? 'calc(100% - 31px)' : '100%',
          }}
        >
          <p
            style={{
              fontWeight: 600,
              height: 32,
              display: 'flex',
              alignItems: 'flex-end',
              marginBottom: 10,
            }}
          >
            {t('已选择')}
            <span style={{ color: '#558492' }}>{checked.length || 0}</span>
            {t('个需要的评估目标')}
          </p>
          <div
            style={{
              border: '1px solid #D9D9D9',
              borderRadius: 6,
              marginTop: 10,
              height: 'calc(100vh - 570px)',
              minHeight: 220,
              padding: '12px 0 12px 12px',
              overflowY: 'auto',
            }}
            ref={containerRef}
          >
            <div
              ref={wrapperRef}
              key={
                debounceSearchName !== '' || tagIds.length > 0 ? selectList.length : mapList.size
              }
            >
              {list?.map(
                (item, index) =>
                  mapList?.get(item.data) && (
                    <div key={item.data} className="assess" style={{ marginRight: 10 }}>
                      <Typography.Text
                        ellipsis={{
                          tooltip: {
                            getPopupContainer: () => document.body,
                          },
                        }}
                        style={{ width: '300px' }}
                      >
                        {mapList?.get(item.data)}
                      </Typography.Text>
                      <IconFont
                        type="icon-shanchu-m"
                        onClick={() => {
                          mapList.delete(item.data)
                          setMapList(mapList)
                          let arr = [...selectList]
                          arr.splice(index, 1)
                          setSelectList(arr)
                          setChecked([...mapList].flat().filter(i => mapList.get(i)))
                        }}
                      />
                    </div>
                  ),
              )}
            </div>
          </div>
        </div>
      </div>
    </ModalContent>
  )
}
/**第六步任务概览 */
const Overview = () => {
  const { dispatch, data } = useCreateTaskContext()
  const { submitData, isCompress } = data
  const {
    editEmail,
    selectOfficeTemplate,
    selectFishingTemplate,
    selectEmailTemplate,
    taskType,
    groups,
    tagList,
    deptList,
    targetIds,
  } = submitData

  const { setSteps, setCreateVisibel, setSubmitData } = dispatch
  const navigator = useNavigate()
  const [createTask, createTaskLoading] = useCreateTask()
  const [smtpList, getSmtpList] = useGetCampaignSmtp()
  const [getSecyTemplate, getSecyTemplateLoading, secyTemplate] = useGetSecyTemplate()

  useEffect(() => {
    getSmtpList({ email_type: submitData?.taskType == 0 ? '恶意附件' : '钓鱼链接' }).catch(_ => {})
    getSecyTemplate({ limit: 9999, page: 1, keyword: '' }).catch(_ => {})
  }, [])
  let securityUrl = ''
  if (taskType == 1) {
    securityUrl = secyTemplate?.filter(item => item.id == selectFishingTemplate?.secyId)[0]
      ?.redirect
  } else {
    securityUrl = secyTemplate?.filter(item => item.id == selectOfficeTemplate?.secyId)[0]?.redirect
  }

  const createTaskHandler = async () => {
    if (email?.length > 10) {
      Message.open({
        type: 'info',
        content: t('邮箱账号最多十个'),
        className: 'info',
        icon: <IconFont type={'icon-tishi1'} style={{ color: '#5890FF' }} />,
      })
      return
    }
    console.log(submitData, editEmail)
    // return
    const datas: CreateTaskData = {
      start_time: submitData?.start_time || moment().format('YYYY-MM-DD HH:mm:ss'),
      end_time: submitData?.start_time
        ? moment(submitData?.start_time)
            .add(submitData.execution, 'd')
            .format('YYYY-MM-DD HH:mm:ss')
        : moment().add(submitData.execution, 'd').format('YYYY-MM-DD HH:mm:ss'),
      page_id: taskType === 1 ? selectFishingTemplate?.select?.id : '',
      url: !submitData?.is_secy
        ? taskType === 1
          ? selectFishingTemplate?.select?.redirect
          : selectOfficeTemplate?.redirect
        : securityUrl,
      email_type: taskType === 1 ? '钓鱼链接' : '恶意附件',
      email_content: editEmail.content,
      email_subject: editEmail.email_subject,
      targets: groups,
      attach_id: taskType === 0 ? selectOfficeTemplate?.select?.id : '',
      campaign_name: submitData.taskName,
      email_name: editEmail.email_name,
      email_cover: editEmail.email_cover,
      email_id: editEmail.email_id,
      email_link: editEmail.email_link,
      dept_str: deptList?.join(','),
      tag_str: tagList?.join(','),
      notice_mail: aotuEmail ? email.join(',') : '',
      email_sender: editEmail.email_sender,
      set_time: submitData?.start_time,
      set_day: submitData.execution,
      set_type: submitData.set_type,
      email_from: selectEmailTemplate.select?.origin_type,
      group_id_list: targetIds?.join(','),
      zip_pwd: editEmail?.compress,
      attach_name:
        taskType === 0
          ? selectOfficeTemplate?.fileName +
            selectOfficeTemplate.select.attachment_name.substring(
              selectOfficeTemplate.select.attachment_name.lastIndexOf('.'),
            )
          : '',
      interval: interval,
      smtp_id: submitData?.smtp_id,
      // security_id: submitData?.is_secy ? 1 : 0,
      security_id: submitData?.is_secy
        ? taskType === 1
          ? selectFishingTemplate?.secyId
          : selectOfficeTemplate?.secyId
        : '0',
      is_commit_data: submitData?.is_commit_data === false ? 2 : 1,
      is_compressed: isCompress,
    }
    try {
      await createTask(datas)
      setCreateVisibel(false)
      setSubmitData({
        selectEmailTemplate: {
          page: 1,
          limit: 99999,
        },
        selectOfficeTemplate: {
          page: 1,
          limit: 99999,
        },
        selectFishingTemplate: {
          page: 1,
          limit: 99999,
        },
      })
      setSteps(1)
      localStorage.removeItem('emailText')
      navigator('/validation/awareness/phishing?tab=task')
    } catch (error) {}
  }
  let name = ''
  if (taskType === 0) {
    name = selectOfficeTemplate.select?.attachment_name
  } else if (taskType === 1) {
    name = selectFishingTemplate.select.name
  }
  const [aotuEmail, setAutoEmail] = useState(false)
  const [email, setEmail] = useState<string[]>()
  const [interval, setInterval] = useState(1)
  const { run } = useRequest(
    (e): any => {
      setInterval(e)
    },
    {
      debounceWait: 300, // 防抖等待时间, 单位为毫秒，设置后，进入防抖模式
      manual: true,
    },
  )
  const { run: emailValue } = useRequest(
    (e): any => {
      let arr = []
      e?.map(item => {
        if (item !== '') {
          arr.push(item)
        }
      })
      setEmail(Array.from(new Set(arr)))
    },
    {
      debounceWait: 300, // 防抖等待时间, 单位为毫秒，设置后，进入防抖模式
      manual: true,
    },
  )
  return (
    <ModalContent>
      <div className="body-redirect" style={{ padding: '0 40px' }}>
        <div style={{ display: 'flex' }}>
          <OverviewTemplate>
            {editEmail?.compress !== '' && editEmail?.compress && (
              <div className="gzip">
                <IconFont type="icon-suoping" /> <span>{t('压缩加密')}</span>
              </div>
            )}
            <div className="content">
              {taskType === 0 ? (
                <TaskTypeItemFolder style={{ height: 134 }}>
                  <IconFont type="icon-wenjianleixing-biaozhuntu-wenjianjia" />
                  <IconFont type="icon-bug" className="icon" />
                </TaskTypeItemFolder>
              ) : (
                <TaskTypeItemFolder style={{ height: 134 }}>
                  <SvgIcon name={'phishing'} style={{ width: 64, height: 64 }} />
                  <IconFont type="icon-youqinglianjie-lianjie" className="icon" />
                </TaskTypeItemFolder>
              )}
              <div style={{ width: 0, flexGrow: 1, paddingLeft: '26px', lineHeight: 1 }}>
                <div style={{ padding: '5px 0' }}>
                  {t('任务类型：')}
                  {submitData?.taskType === 0 ? t('恶意附件') : t('钓鱼链接')}
                </div>

                <div
                  style={{
                    padding: '5px 0',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    lineHeight: 1,
                  }}
                >
                  {t('邮件模板名称：')}

                  <Tooltip
                    placement="topLeft"
                    title={submitData?.selectEmailTemplate?.select?.name}
                  >
                    {submitData?.selectEmailTemplate?.select?.name}
                  </Tooltip>
                </div>
                <div
                  style={{
                    width: '90%',
                    padding: '5px 0',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    lineHeight: 1,
                  }}
                  title={submitData.groups?.map(item => item.Name).join('，')}
                >
                  {t('执行类型：')}
                  {submitData.set_type === 1 ? t('立即') : t('预定')} &nbsp;
                  <span>{submitData?.start_time}</span>
                </div>
                {name && (
                  <div
                    style={{
                      padding: '5px 0',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      lineHeight: 1,
                    }}
                  >
                    {submitData?.taskType === 0 ? t('附件：') : t('钓鱼页模板：')}
                    <Tooltip placement="topLeft" title={name}>
                      {selectOfficeTemplate?.fileName ? selectOfficeTemplate?.fileName : name}
                    </Tooltip>
                  </div>
                )}
                <div
                  style={{
                    width: '90%',
                    padding: '5px 0 0',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    lineHeight: 1,
                  }}
                  title={submitData.deptList?.join('，')}
                >
                  {t('评估目标：')}
                  {submitData.deptList?.join('，')}
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      background: '#4238C9',
                      color: '#fff',
                      width: 60,
                      cursor: 'pointer',
                      marginTop: 5,
                      fontSize: 12,
                      padding: '5px 6px',
                      borderRadius: 4,
                      lineHeight: 1,
                    }}
                    onClick={() => {
                      // setSubmitData({
                      //   selectEmailTemplate: {
                      //     page: 1,
                      //     limit: 10,
                      //   },
                      //   selectOfficeTemplate: {
                      //     page: 1,
                      //     limit: 10,
                      //   },
                      //   selectFishingTemplate: {
                      //     page: 1,
                      //     limit: 10,
                      //   },
                      // })
                      setSteps(1)
                    }}
                  >
                    {t('重新编辑')}
                  </div>
                </div>
              </div>
            </div>
          </OverviewTemplate>
          <OverviewTemplate style={{ marginLeft: '20px', lineHeight: 1 }}>
            <div className="content" style={{ display: 'block', lineHeight: 1 }}>
              <Checkbox
                onChange={e => {
                  setAutoEmail(e.target.checked)
                }}
              >
                {t('任务结束后将评估报表自动发送到邮箱（不超过10个）')}
              </Checkbox>
              <Input.TextArea
                rows={4}
                style={{ marginTop: '16px', resize: 'none', height: 104 }}
                disabled={!aotuEmail}
                onChange={e => {
                  emailValue(e.target.value.split('\n'))
                }}
                placeholder={t('多个邮箱账号以换行隔开：\n name@example.com\n name@example.com')}
              />
            </div>
          </OverviewTemplate>
        </div>
        <div
          style={{
            marginBottom: '12px',
            backgroundColor: '#F7F7F7',
            padding: '16px',
            borderRadius: '6px',
          }}
        >
          {/* <div style={{ padding: '6px 0' }}>
             <span>发件服务器地址:</span>
             <span style={{ color: '#031A79' }}>
               {data.ip?.split(',')?.[0] === data.ip?.split(',')?.[1]
                 ? data.ip?.split(',')?.[0]
                 : data.ip?.split(',')?.[1] != ''
                 ? data.ip
                 : data.ip?.split(',')?.[0]}
             </span>
            </div> */}
          <div style={{ display: 'flex' }}>
            <div style={{ width: '30%', borderRight: '1px solid #DFDFDF' }}>
              <div>{t('发件地址')}</div>
              <div style={{ paddingTop: 10 }}>
                {/* {data.ip?.split(',')?.[0] === data.ip?.split(',')?.[1]
                   ? data.ip?.split(',')?.[0]
                   : data.ip?.split(',')?.[1] != ''
                   ? data.ip
                   : data.ip?.split(',')?.[0]} */}
                {submitData?.smtp_url}
              </div>
            </div>
            <div style={{ paddingLeft: 24 }}>
              <div>
                <span>{t('发件服务器')}</span>
                <span style={{ fontSize: 12, color: '#999999' }}>
                  {t('（为确保您的员工能收到电子邮件，请将发件服务器加入邮件网关白名单策略中）')}
                </span>
              </div>
              <div style={{ paddingTop: 10 }}>
                {smtpList?.filter(item => item.id == submitData?.smtp_id)[0]?.send_server || '-'}
              </div>
            </div>
          </div>
          {/* <img src={OverviewLine} style={{ width: '100%', height: 1 }} /> */}
          <div style={{ width: '100%', height: 1, background: '#D9D9D9', marginTop: 25 }} />
          <div style={{ paddingTop: 16 }}>
            <div>{t('邮件发送频率（1s-600s）')}</div>
            <div style={{ marginTop: 8 }}>
              <InputNumber
                max={600}
                min={1}
                style={{ width: 260 }}
                defaultValue={1}
                precision={0}
                parser={test => (/^\d+$/.test(test) ? test : 1)}
                keyboard={false}
                onChange={e => {
                  run(e)
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <ArticleSteps currentNum={7} length={6} />
        <Space>
          <Button
            onClick={() => {
              setCreateVisibel(false)
              setSubmitData({
                selectEmailTemplate: {
                  page: 1,
                  limit: 99999,
                },
                selectOfficeTemplate: {
                  page: 1,
                  limit: 99999,
                },
                selectFishingTemplate: {
                  page: 1,
                  limit: 99999,
                },
              })
              setSteps(1)
            }}
          >
            {t('取消')}
          </Button>
          <Button
            onClick={() => {
              setSteps(origin => origin - 1)
            }}
          >
            {t('上一步')}
          </Button>
          <Button type={'primary'} onClick={createTaskHandler} loading={createTaskLoading}>
            {t('创建任务')}
          </Button>
        </Space>
      </div>
    </ModalContent>
  )
}

interface CreateTaskContextValue {
  data: {
    isCompress: boolean
    password: string
    steps: number
    submitData: SubmitData
    // ip: string
  }
  dispatch: {
    setIsCompress: Dispaths<boolean>
    setPassword: Dispaths<string>
    setSteps: Dispaths<number>
    setSubmitData: Dispaths<SubmitData>
    setCreateVisibel: Dispaths<boolean>
  }
}

interface SubmitData {
  start_time?: string
  taskName?: string
  selected?: string[]
  taskType?: 0 | 1
  execution?: number
  set_type?: number
  smtp_id?: string
  smtp_url?: string
  is_secy?: boolean
  is_commit_data?: boolean
  selectEmailTemplate: {
    page: number
    limit: number
    select?: any
    content?: any
    email_name?: string
    email_sender?: string
    email_cover?: string
    email_id?: string
    email_link?: string
  }
  selectOfficeTemplate: {
    page: number
    limit: number
    select?: any
    redirect?: string
    fileName?: string
    suffix?: string
    radioVal?: number
    secyUrl?: string
    secyId?: string
  }
  selectFishingTemplate: {
    page: number
    limit: number
    select?: any
    radioVal?: number
    secyUrl?: string
    secyId?: string
  }
  editEmail?: {
    title: string
    content: string
    template_id: string
    email_name: string
    email_id: string
    email_link?: string
    email_sender: string
    email_cover: string
    email_subject: string
    compress: string
  }
  redirect?: string
  groups?: any[]
  deptList?: any[]
  targetIds?: any[]
  tagList?: any[]
}

const createTaskContext = React.createContext<CreateTaskContextValue | null>(null)

const useCreateTaskContext = () => {
  const res = useContext(createTaskContext)
  if (res === null) {
    throw new Error(t('应在新建任务弹窗中使用该hook'))
  }
  return res
}

export const CreateTask = () => {
  const [createVisibel, setCreateVisibel] = useState(false)
  const [submitData, setSubmitData] = useState<SubmitData>({
    selectEmailTemplate: {
      page: 1,
      limit: 99999,
    },
    selectOfficeTemplate: {
      page: 1,
      limit: 99999,
    },
    selectFishingTemplate: {
      page: 1,
      limit: 99999,
    },
  })
  const [steps, setSteps] = useState(1)
  const [isCompress, setIsCompress] = useState<boolean>(false)
  const [password, setPassword] = useState('')
  const [title, setTitle] = useState(t('基本配置'))
  // const [getIp, ipLoad, ip] = useGetIp()
  useEffect(() => {
    switch (steps) {
      case 1:
        setTitle(t('基本配置'))
        break
      case 2:
        setTitle(t('任务类型'))
        break
      case 3:
        setTitle(t('邮件模板'))
        break
      case 4:
        setTitle(t('编辑邮件内容'))
        break
      case 5:
        if (submitData?.taskType === 0) {
          setTitle(t('附件模板'))
        } else {
          setTitle(t('钓鱼页模板'))
        }
        break
      case 6:
        setTitle(t('任务概览'))
        break
    }
  }, [steps])

  return (
    <>
      <LeftContainer
        title={
          <SignTitle>
            <>{title}</>
          </SignTitle>
        }
      >
        <createTaskContext.Provider
          value={{
            data: {
              isCompress,
              password,
              steps,
              submitData,
              // ip,
            },
            dispatch: {
              setIsCompress,
              setPassword,
              setSteps,
              setSubmitData,
              setCreateVisibel,
            },
          }}
        >
          {steps === 1 && <TaskName />}
          {steps === 2 && <TaskType />}
          {steps === 3 && <TempalteAssets />}
          {steps === 4 && <EditEmail />}
          {steps === 5 && (submitData.taskType === 0 ? <OfficeTemplate /> : <GofishingTemplate />)}
          {steps === 6 && <Overview />}
        </createTaskContext.Provider>
      </LeftContainer>
      <RightContainer
        title={
          <div className="right-title">
            {(steps === 1 && t('配置任务基本信息')) ||
              (steps === 2 && t('钓鱼邮件类型')) ||
              (steps === 3 &&
                (submitData.taskType === 0
                  ? t('适用于恶意附件的邮件模板')
                  : t('适用于钓鱼链接的邮件模板'))) ||
              (steps === 4 && t('预览并编辑邮件内容')) ||
              (steps === 5 && (submitData.taskType === 0 ? t('恶意附件') : t('钓鱼页面'))) ||
              (steps === 6 && t('任务已配置完成'))}
          </div>
        }
      >
        <Scrollbars>
          <div style={{ paddingRight: 10 }}>
            {steps === 1 && <TaskNameRight />}
            {steps === 2 && <TaskTypeRight />}
            {steps === 3 &&
              (submitData.taskType === 0 ? <TaskAccessoryRight /> : <TaskPhishingRight />)}
            {steps === 4 &&
              (submitData.taskType === 0 ? (
                <>
                  <AttachmentRight />
                  <TaskEmailEncryption />
                </>
              ) : (
                <TaskEmailRight />
              ))}
            {steps === 5 &&
              (submitData.taskType === 0 ? (
                <>
                  <TaskSpiteRight />
                  <TaskRedirectRight />
                </>
              ) : (
                <>
                  <TaskPhishRight />
                  <TaskRedirectRight />
                </>
              ))}
            {/* {steps === 6 && <TaskRedirectRight />} */}
            {steps === 6 && <TaskOverRight />}
          </div>
        </Scrollbars>
      </RightContainer>
    </>
  )
}

const RightContainer = styled(Card)`
  min-height: 100%;
  width: 30%;
  border-radius: 8px;
  box-shadow: 0px 4px 8px 0px rgba(95, 103, 129, 0.06);
  .right-title {
    font-size: 16px;
  }
`

const LeftContainer = styled(Card)`
  min-height: 100%;
  width: calc(70% - 16px);
  border-radius: 8px;
  margin-right: 16px;
  box-shadow: 0px 4px 8px 0px rgba(95, 103, 129, 0.06);
`
const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .encryption::before {
    content: '*';
    position: absolute;
    color: red;
    left: 52px;
    font-size: 14px;
  }
  .ai-btn:hover {
    background: linear-gradient(45deg, #2090a8 0%, #4f4fae 100%) !important;
  }

  .tasks-background {
    width: 100%;
    background: #f7f8fa;
    border-radius: 8px;
    display: flex;
    padding: 24px;
    /* margin-top: 24px; */
    position: relative;
  }
  .form-position {
    position: absolute;
    right: 26px;
    top: 55px;
    font-size: 14px;
    color: #666666;
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
    box-shadow: unset;
  }
  .ant-row {
    height: 100%;
  }
  .redirect > .ant-row {
    height: auto;
  }
  .tree-main {
    height: 100%;
    padding-left: 14px;
    line-height: 32px;
    &:hover {
      background: #e7e9f3;
      border-radius: 6px;
    }
  }
  .selected {
    width: 100%;
    padding-left: 20px;
  }
  .body-redirect {
    height: 100%;
  }
  .body {
    width: 100%;
    display: flex;
    flex-grow: 1;
    /* overflow: hidden; */
    height: 100%;
    .ant-picker {
      margin-top: 2px;
    }
    .title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .day {
      margin-left: 8px;
    }
    .redirect-wrapper {
      padding: 16px 24px;
      background: #f7f8fa;
      border-radius: 8px;
      position: relative;
      .ant-form-item {
        margin-bottom: 0;
      }
    }
    .redirect-wrapper::before {
      content: '';
      position: absolute;
      display: block;
      width: calc(100% + 40px);
      height: 1px;
      background: #eaedf1;
      top: -16px;
      transform: translateX(-44px);
    }
  }
  .ant-form-item-control-input {
    height: 100%;
  }
  .ant-form-item-control-input-content {
    height: 100%;
  }
  .send-wrapper {
    height: 96px;
    background: #f7f8fa;
    border-radius: 8px;
    margin-bottom: 24px;
    position: relative;
    .ant-form-item {
      margin-bottom: 0;
    }
  }
  .send-wrapper::before {
    content: '';
    position: absolute;
    display: block;
    width: calc(100% + 40px);
    height: 1px;
    background: #eaedf1;
    top: -16px;
    transform: translateX(-20px);
  }
  .footer {
    max-height: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .ant-steps {
      width: 25%;
      .ant-steps-item-wait {
        .ant-steps-item-icon {
          background-color: #d9d9d9;
          border: none;
          .ant-steps-icon {
            color: #fff;
          }
        }
      }
      .ant-steps-item-icon {
        border-radius: 4px;
        margin-right: 0;
      }
    }
    .ant-steps-item {
      padding-left: 0 !important;
      .ant-steps-item-container {
        .ant-steps-item-tail {
          display: block;
          top: 12px;
          left: 14px;
        }
      }
    }
  }
  .assess {
    display: flex;
    padding: 0 16px;
    justify-content: space-between;
    line-height: 32px;
    border-radius: 6px;
    align-items: center;
    &:hover {
      background-color: #e7e9f3;
    }
  }
  .attachment {
    margin-top: 10px;
    width: 250px;
    .flex {
      display: flex;
      align-items: center;
      .name {
        margin: 0 12px;
        display: inline-block;
        // height: 32px;
        // line-height: 32px;
      }
    }
  }
  .target {
    .ant-card-head {
      padding: 0;
    }
    .ant-card-head-title {
      padding: 0;
    }
  }
  .ant-tree-indent {
    order: 1;
  }
  .ant-tree-switcher {
    order: 3;
    width: 12px;
  }
  .ant-tree-checkbox {
    order: 2;
  }
  .ant-tree-node-content-wrapper {
    order: 4;
  }
  .ant-tree-switcher-noop {
    display: none;
  }
  .ant-tree-checkbox-inner {
    border-radius: 2px !important;
  }
  .ant-tree-treenode {
    border-radius: 6px;
    display: flex;
    height: 32px;
    align-items: center;
    width: calc(100% - 10px);
    padding: 0 6px;
    .ant-tree-switcher {
      display: flex;
      align-items: center;
    }
    .ant-tree-checkbox {
      margin-top: 0;
    }
    &:hover {
      background: #e7e9f3;
    }
  }
`

const TaskTypeItemFolder = styled.div`
  display: inline-block;
  position: relative;
  font-size: 100px;
  z-index: 101;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    width: 27px;
    height: 30px;
    font-size: 27px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    transform: translateY(10px);
    color: #fff;
  }
`

interface TaskTypeItemContainerProps {
  active?: boolean
}
const TaskTypeItemContainer = styled.div<TaskTypeItemContainerProps>`
  position: relative;
  border-radius: 12px !important;
  /* z-index: 98; */
  &::before {
    content: '';
    display: block;
    position: absolute;
    background-color: #eff4fe;
    top: 0px;
    border-radius: 8px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    z-index: 100;
  }
  &:after {
    content: '';
    display: block;
    position: absolute;
    top: -2px;
    bottom: -2px;
    left: -2px;
    right: -2px;
    background: ${(props: { active: any }) => (props.active ? '#576CD1' : 'unset')};
    border-radius: 8px;
    z-index: 99;
  }
  cursor: pointer;
  height: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  transition: box-shadow 0.3s;
  box-shadow: ${(props: { active: any }) =>
    props.active ? '0px 2px 14px 0px rgba(0, 0, 0, 0.15)' : 'unset'};
  &:hover {
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.15);
  }
  .text {
    z-index: 102;
    margin-top: 25px;
    font-size: 16px;
    font-weight: 600;
  }
`

const TemplateItemList = styled.div`
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(auto-fill, minmax(284px, 1fr));
  width: 100%;
  padding: 10px;
  overflow: auto;
`

const OverviewTemplate = styled.div`
  width: 50%;
  height: 170px;
  border-radius: 8px;
  padding: 16px;
  position: relative;
  margin: 24px 0;
  border: 1px solid #d9d9d9;
  overflow: hidden;
  .gzip {
    position: absolute;
    color: #f53f3f;
    background: #feebeb;
    font-size: 12px;
    width: 200px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    left: -65px;
    top: 15px;
    transform: rotateZ(325deg);
  }
  .content {
    position: relative;
    z-index: 3;
    padding-left: 10px;
    display: flex;
    .title {
      font-weight: normal;
    }
  }
  .ant-card-body {
    display: flex;
    flex-direction: column;
    margin-top: 15px;
    width: 320px;
  }
  textarea::-webkit-input-placeholder {
    font-style: italic;
  }
  .template-img {
    width: 88px;
    height: 117px;
    border-radius: 8px;
  }
`

interface SubsetProps {
  isActive: boolean
}
const Subset = styled.div<SubsetProps>`
  line-height: 32px;
  display: ${(props: { isActive: any }) => (props.isActive ? 'unset' : 'none')};
  .subset-tag_list {
    padding-left: 60px;
    .ant-checkbox-wrapper {
      width: 100%;
    }
    .ant-checkbox + span {
      display: block;
      width: 90%;
    }
    &:hover {
      background: #e7e9f3;
      border-radius: 6px;
    }
    &:hover .tree-main {
      background: transparent;
      border-radius: 6px;
    }
  }
`
const Svg = styled(SvgIcon)`
  width: 16px;
  height: 16px;
`
const AddEmailModal = styled(Modal)`
  .ant-modal-body {
    padding-top: 0;
    overflow-y: scroll;
  }

  .ant-modal-footer {
    padding-top: 24px;
  }

  .email-main {
    height: 406px;
    padding-right: 15px;
    overflow-y: auto;
  }

  .add {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 12px;
    border-top: 1px solid #eaedf1;
  }
`
